var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _g4, _path14, _path15, _path16, _path17, _circle3, _circle4, _path18, _path19, _path20, _path21, _path22, _path23, _g5, _g6, _path24, _path25, _path26, _path27, _circle5, _circle6, _path28, _path29, _path30, _path31, _path32, _path33, _g7, _g8, _path34, _path35, _path36, _path37, _circle7, _circle8, _path38, _path39, _path40, _path41, _path42, _path43, _g9, _g10, _path44, _path45, _path46, _path47, _circle9, _circle10, _path48, _path49, _g11, _g12, _path50, _path51, _path52, _path53, _circle11, _circle12, _path54, _path55, _g13, _g14, _path56, _path57, _path58, _path59, _circle13, _circle14, _path60, _path61, _g15, _g16, _path62, _path63, _path64, _path65, _circle15, _circle16, _path66, _path67, _g17, _g18, _path68, _path69, _path70, _path71, _circle17, _circle18, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g19, _g20, _path79, _path80, _path81, _path82, _circle19, _circle20, _path83, _path84, _path85, _path86, _path87, _path88, _g21, _g22, _path89, _path90, _path91, _path92, _circle21, _circle22, _path93, _path94, _path95, _path96, _path97, _path98, _g23, _g24, _path99, _path100, _path101, _path102, _circle23, _circle24, _path103, _path104, _path105, _path106, _path107, _path108, _g25, _g26, _path109, _path110, _path111, _path112, _circle25, _circle26, _path113, _path114, _path115, _path116, _path117, _path118, _g27, _g28, _path119, _path120, _path121, _path122, _circle27, _circle28, _path123, _path124, _g29, _g30, _path125, _path126, _path127, _path128, _circle29, _circle30, _path129, _path130, _g31, _g32, _path131, _path132, _path133, _path134, _circle31, _circle32, _path135, _path136, _g33, _g34, _path137, _path138, _path139, _path140, _circle33, _circle34, _path141, _path142, _g35, _g36, _path143, _path144, _path145, _path146, _circle35, _circle36, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _g37, _g38, _path155, _path156, _path157, _path158, _circle37, _circle38, _path159, _path160, _path161, _path162, _path163, _g39, _g40, _path164, _path165, _path166, _path167, _circle39, _circle40, _path168, _path169, _path170, _path171, _path172, _g41, _g42, _path173, _path174, _path175, _path176, _circle41, _circle42, _path177, _path178, _path179, _path180, _path181, _g43, _g44, _path182, _path183, _path184, _path185, _circle43, _circle44, _path186, _path187, _path188, _path189, _path190, _g45, _g46, _path191, _path192, _path193, _path194, _circle45, _circle46, _path195, _path196, _g47, _g48, _path197, _path198, _path199, _path200, _circle47, _circle48, _path201, _path202, _path203, _path204, _path205, _g49, _g50, _path206, _path207, _path208, _path209, _circle49, _circle50, _path210, _path211, _path212, _path213, _path214, _g51, _g52, _path215, _path216, _path217, _path218, _circle51, _circle52, _path219, _path220, _path221, _path222, _path223, _g53, _g54, _path224, _path225, _path226, _path227, _circle53, _circle54, _path228, _path229, _path230, _path231, _path232, _g55, _g56, _path233, _path234, _path235, _path236, _circle55, _circle56, _path237, _path238, _path239, _path240, _path241, _g57, _g58, _path242, _path243, _path244, _path245, _circle57, _circle58, _path246, _path247, _g59, _g60, _path248, _path249, _path250, _path251, _circle59, _circle60, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _g61, _g62, _path263, _path264, _path265, _path266, _circle61, _circle62, _path267, _path268, _path269, _path270, _path271, _path272, _g63, _g64, _path273, _path274, _path275, _path276, _circle63, _circle64, _path277, _path278, _path279, _path280, _path281, _path282, _g65, _g66, _path283, _path284, _path285, _path286, _circle65, _circle66, _path287, _path288, _path289, _path290, _path291, _path292, _g67, _g68, _path293, _path294, _path295, _path296, _circle67, _circle68, _path297, _path298, _path299, _path300, _path301, _path302, _g69, _g70, _path303, _path304, _path305, _path306, _circle69, _circle70, _path307, _path308, _g71, _g72, _path309, _path310, _path311, _path312, _circle71, _circle72, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _g73, _g74, _path320, _path321, _path322, _path323, _circle73, _circle74, _path324, _path325, _path326, _path327, _path328, _path329, _g75, _g76, _path330, _path331, _path332, _path333, _circle75, _circle76, _path334, _path335, _path336, _path337, _path338, _path339, _g77, _g78, _path340, _path341, _path342, _path343, _circle77, _circle78, _path344, _path345, _path346, _path347, _path348, _path349, _g79, _g80, _path350, _path351, _path352, _path353, _circle79, _circle80, _path354, _path355, _path356, _path357, _path358, _path359, _g81, _g82, _path360, _path361, _path362, _path363, _circle81, _circle82, _path364, _path365, _g83, _g84, _path366, _path367, _path368, _path369, _circle83, _circle84, _path370, _path371, _g85, _g86, _path372, _path373, _path374, _path375, _circle85, _circle86, _path376, _path377, _g87, _g88, _path378, _path379, _path380, _path381, _circle87, _circle88, _path382, _path383, _g89, _g90, _path384, _path385, _path386, _path387, _circle89, _circle90, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _g91, _g92, _path396, _path397, _path398, _path399, _circle91, _circle92, _path400, _path401, _path402, _path403, _path404, _path405, _g93, _g94, _path406, _path407, _path408, _path409, _circle93, _circle94, _path410, _path411, _path412, _path413, _path414, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTifiJackpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 329,
    viewBox: "0 0 315 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter0_f_2550_59381)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.703 218C140.891 218 153.203 223.82 153.203 231C153.203 238.18 140.891 244 125.703 244C110.515 244 98.2031 238.18 98.2031 231C98.2031 223.82 110.515 218 125.703 218Z",
    fill: "#CCCCCC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1595 219.996C91.1595 225.316 94.5418 230.635 101.306 234.694C114.836 242.812 136.771 242.812 150.3 234.694C157.065 230.635 160.447 225.316 160.447 219.996V211.026C160.447 205.707 157.065 200.387 150.3 196.328C136.771 188.211 114.836 188.211 101.306 196.328C94.5418 200.387 91.1595 205.707 91.1595 211.026V219.996Z",
    fill: "url(#paint0_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 190,
    width: 70,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1595 219.996C91.1595 225.316 94.5418 230.635 101.306 234.694C114.836 242.812 136.771 242.812 150.3 234.694C157.065 230.635 160.447 225.316 160.447 219.996V211.026C160.447 205.707 157.065 200.387 150.3 196.328C136.771 188.211 114.836 188.211 101.306 196.328C94.5418 200.387 91.1595 205.707 91.1595 211.026V219.996Z",
    fill: "url(#paint1_linear_2550_59381)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.604 215.277L120.138 214.707L123.786 228.387V240.813H103.038V223.257L116.604 215.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.522 223.142L134.151 219.152L139.062 227.018V240.812H128.333V228.781L126.522 223.142Z",
    fill: "#33B6FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 125.803 210.744)",
    fill: "#0F8BFB"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.202 206.393H126.106L126.213 206.534L127.932 208.801L125.739 210.349L122.88 206.621L123.202 206.393Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.106 206.393H123.202L122.88 206.621L113.738 213.102H116.908L126.213 206.534L126.106 206.393Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.412 214.631H122.509L122.402 214.49L120.682 212.222L122.875 210.674L125.734 214.402L125.412 214.631Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.509 214.631H125.412L125.734 214.402L134.876 207.921H131.706L122.402 214.49L122.509 214.631Z",
    fill: "#F5F5F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 125.803 210.326)",
    stroke: "url(#paint2_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 125.803 210.326)",
    stroke: "url(#paint3_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.429 210.261L132.186 209.955V210.411L131.637 210.627L131.429 210.261Z",
    fill: "#0B68BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.954 211.544L143.707 211.236V211.692L143.158 211.916L142.954 211.544Z",
    fill: "#0B68BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.944 211.233L108.13 211.016V211.47L108.758 211.639L108.944 211.233Z",
    fill: "#0B68BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.011 213.134L119.652 212.295V212.75L119.858 213.217L120.011 213.134Z",
    fill: "#0B68BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1595 203.996C92.1595 209.316 95.5418 214.635 102.306 218.694C115.836 226.812 137.771 226.812 151.3 218.694C158.065 214.635 161.447 209.316 161.447 203.996V195.026C161.447 189.707 158.065 184.387 151.3 180.328C137.771 172.211 115.836 172.211 102.306 180.328C95.5418 184.387 92.1595 189.707 92.1595 195.026V203.996Z",
    fill: "url(#paint4_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 174,
    width: 70,
    height: 51
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1595 203.996C92.1595 209.316 95.5418 214.635 102.306 218.694C115.836 226.812 137.771 226.812 151.3 218.694C158.065 214.635 161.447 209.316 161.447 203.996V195.026C161.447 189.707 158.065 184.387 151.3 180.328C137.771 172.211 115.836 172.211 102.306 180.328C95.5418 184.387 92.1595 189.707 92.1595 195.026V203.996Z",
    fill: "url(#paint5_linear_2550_59381)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.604 199.277L121.138 198.707L124.786 212.387V224.813H104.038V207.257L117.604 199.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.522 207.142L135.151 203.152L140.062 211.018V224.812H129.333V212.781L127.522 207.142Z",
    fill: "#33B6FF"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 194.744)",
    fill: "#0F8BFB"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.202 190.393H127.106L127.213 190.534L128.932 192.801L126.739 194.349L123.88 190.621L124.202 190.393Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.106 190.393H124.202L123.88 190.621L114.738 197.102H117.908L127.213 190.534L127.106 190.393Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.412 198.631H123.509L123.402 198.49L121.682 196.222L123.875 194.674L126.734 198.402L126.412 198.631Z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.509 198.631H126.412L126.734 198.402L135.876 191.921H132.706L123.402 198.49L123.509 198.631Z",
    fill: "#F5F5F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 194.326)",
    stroke: "url(#paint6_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 194.326)",
    stroke: "url(#paint7_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.429 194.261L133.186 193.955V194.411L132.637 194.627L132.429 194.261Z",
    fill: "#0B68BC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.954 195.544L144.707 195.236V195.692L144.158 195.916L143.954 195.544Z",
    fill: "#0B68BC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.944 195.233L109.13 195.016V195.47L109.758 195.639L109.944 195.233Z",
    fill: "#0B68BC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.011 197.134L120.652 196.295V196.75L120.858 197.217L121.011 197.134Z",
    fill: "#0B68BC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1595 184.996C92.1595 190.316 95.5418 195.635 102.306 199.694C115.836 207.812 137.771 207.812 151.3 199.694C158.065 195.635 161.447 190.316 161.447 184.996V176.026C161.447 170.707 158.065 165.387 151.3 161.328C137.771 153.211 115.836 153.211 102.306 161.328C95.5418 165.387 92.1595 170.707 92.1595 176.026V184.996Z",
    fill: "url(#paint8_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 155,
    width: 70,
    height: 51
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1595 184.996C92.1595 190.316 95.5418 195.635 102.306 199.694C115.836 207.812 137.771 207.812 151.3 199.694C158.065 195.635 161.447 190.316 161.447 184.996V176.026C161.447 170.707 158.065 165.387 151.3 161.328C137.771 153.211 115.836 153.211 102.306 161.328C95.5418 165.387 92.1595 170.707 92.1595 176.026V184.996Z",
    fill: "url(#paint9_linear_2550_59381)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.604 180.277L121.138 179.707L124.786 193.387V205.813H104.038V188.257L117.604 180.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.522 188.142L135.151 184.152L140.062 192.018V205.812H129.333V193.781L127.522 188.142Z",
    fill: "#33B6FF"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 175.744)",
    fill: "#0F8BFB"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.202 171.393H127.106L127.213 171.534L128.932 173.801L126.739 175.349L123.88 171.621L124.202 171.393Z",
    fill: "#F5F5F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.106 171.393H124.202L123.88 171.621L114.738 178.102H117.908L127.213 171.534L127.106 171.393Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.412 179.631H123.509L123.402 179.49L121.682 177.222L123.875 175.674L126.734 179.402L126.412 179.631Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.509 179.631H126.412L126.734 179.402L135.876 172.921H132.706L123.402 179.49L123.509 179.631Z",
    fill: "#F5F5F5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 175.326)",
    stroke: "url(#paint10_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 175.326)",
    stroke: "url(#paint11_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132.429 175.261L133.186 174.955V175.411L132.637 175.627L132.429 175.261Z",
    fill: "#0B68BC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.954 176.544L144.707 176.236V176.692L144.158 176.916L143.954 176.544Z",
    fill: "#0B68BC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.944 176.233L109.13 176.016V176.47L109.758 176.639L109.944 176.233Z",
    fill: "#0B68BC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.011 178.134L120.652 177.295V177.75L120.858 178.217L121.011 178.134Z",
    fill: "#0B68BC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1595 168.996C92.1595 174.316 95.5418 179.635 102.306 183.694C115.836 191.812 137.771 191.812 151.3 183.694C158.065 179.635 161.447 174.316 161.447 168.996V160.026C161.447 154.707 158.065 149.387 151.3 145.328C137.771 137.211 115.836 137.211 102.306 145.328C95.5418 149.387 92.1595 154.707 92.1595 160.026V168.996Z",
    fill: "url(#paint12_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 139,
    width: 70,
    height: 51
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1595 168.996C92.1595 174.316 95.5418 179.635 102.306 183.694C115.836 191.812 137.771 191.812 151.3 183.694C158.065 179.635 161.447 174.316 161.447 168.996V160.026C161.447 154.707 158.065 149.387 151.3 145.328C137.771 137.211 115.836 137.211 102.306 145.328C95.5418 149.387 92.1595 154.707 92.1595 160.026V168.996Z",
    fill: "url(#paint13_linear_2550_59381)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.604 164.277L121.138 163.707L124.786 177.387V189.813H104.038V172.257L117.604 164.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.522 172.142L135.151 168.152L140.062 176.018V189.812H129.333V177.781L127.522 172.142Z",
    fill: "#33B6FF"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 159.744)",
    fill: "#0F8BFB"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.202 155.393H127.106L127.213 155.534L128.932 157.801L126.739 159.349L123.88 155.621L124.202 155.393Z",
    fill: "#F5F5F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.106 155.393H124.202L123.88 155.621L114.738 162.102H117.908L127.213 155.534L127.106 155.393Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.412 163.631H123.509L123.402 163.49L121.682 161.222L123.875 159.674L126.734 163.402L126.412 163.631Z",
    fill: "#F5F5F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.509 163.631H126.412L126.734 163.402L135.876 156.921H132.706L123.402 163.49L123.509 163.631Z",
    fill: "#F5F5F5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 159.326)",
    stroke: "url(#paint14_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.803 159.326)",
    stroke: "url(#paint15_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M132.429 159.261L133.186 158.955V159.411L132.637 159.627L132.429 159.261Z",
    fill: "#0B68BC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M143.954 160.544L144.707 160.236V160.692L144.158 160.916L143.954 160.544Z",
    fill: "#0B68BC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.944 160.233L109.13 160.016V160.47L109.758 160.639L109.944 160.233Z",
    fill: "#0B68BC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121.011 162.134L120.652 161.295V161.75L120.858 162.217L121.011 162.134Z",
    fill: "#0B68BC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 152.996C93.1595 158.316 96.5418 163.635 103.306 167.694C116.836 175.812 138.771 175.812 152.3 167.694C159.065 163.635 162.447 158.316 162.447 152.996V144.026C162.447 138.707 159.065 133.387 152.3 129.328C138.771 121.211 116.836 121.211 103.306 129.328C96.5418 133.387 93.1595 138.707 93.1595 144.026V152.996Z",
    fill: "url(#paint16_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 123,
    width: 70,
    height: 51
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 152.996C93.1595 158.316 96.5418 163.635 103.306 167.694C116.836 175.812 138.771 175.812 152.3 167.694C159.065 163.635 162.447 158.316 162.447 152.996V144.026C162.447 138.707 159.065 133.387 152.3 129.328C138.771 121.211 116.836 121.211 103.306 129.328C96.5418 133.387 93.1595 138.707 93.1595 144.026V152.996Z",
    fill: "url(#paint17_linear_2550_59381)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.604 148.277L122.138 147.707L125.786 161.387V173.813H105.038V156.257L118.604 148.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.522 156.142L136.151 152.152L141.062 160.018V173.812H130.333V161.781L128.522 156.142Z",
    fill: "#33B6FF"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 143.744)",
    fill: "#0F8BFB"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.202 139.393H128.106L128.213 139.534L129.932 141.801L127.739 143.349L124.88 139.621L125.202 139.393Z",
    fill: "#F5F5F5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.106 139.393H125.202L124.88 139.621L115.738 146.102H118.908L128.213 139.534L128.106 139.393Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.412 147.631H124.509L124.402 147.49L122.682 145.222L124.875 143.674L127.734 147.402L127.412 147.631Z",
    fill: "#F5F5F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.509 147.631H127.412L127.734 147.402L136.876 140.921H133.706L124.402 147.49L124.509 147.631Z",
    fill: "#F5F5F5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 143.326)",
    stroke: "url(#paint18_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 143.326)",
    stroke: "url(#paint19_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 135.996C93.1595 141.316 96.5418 146.635 103.306 150.694C116.836 158.812 138.771 158.812 152.3 150.694C159.065 146.635 162.447 141.316 162.447 135.996V127.026C162.447 121.707 159.065 116.387 152.3 112.328C138.771 104.211 116.836 104.211 103.306 112.328C96.5418 116.387 93.1595 121.707 93.1595 127.026V135.996Z",
    fill: "url(#paint20_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 106,
    width: 70,
    height: 51
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 135.996C93.1595 141.316 96.5418 146.635 103.306 150.694C116.836 158.812 138.771 158.812 152.3 150.694C159.065 146.635 162.447 141.316 162.447 135.996V127.026C162.447 121.707 159.065 116.387 152.3 112.328C138.771 104.211 116.836 104.211 103.306 112.328C96.5418 116.387 93.1595 121.707 93.1595 127.026V135.996Z",
    fill: "url(#paint21_linear_2550_59381)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.604 131.277L122.138 130.707L125.786 144.387V156.813H105.038V139.257L118.604 131.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.522 139.142L136.151 135.152L141.062 143.018V156.812H130.333V144.781L128.522 139.142Z",
    fill: "#33B6FF"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 126.744)",
    fill: "#0F8BFB"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.202 122.393H128.106L128.213 122.534L129.932 124.801L127.739 126.349L124.88 122.621L125.202 122.393Z",
    fill: "#F5F5F5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.106 122.393H125.202L124.88 122.621L115.738 129.102H118.908L128.213 122.534L128.106 122.393Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.412 130.631H124.509L124.402 130.49L122.682 128.222L124.875 126.674L127.734 130.402L127.412 130.631Z",
    fill: "#F5F5F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.509 130.631H127.412L127.734 130.402L136.876 123.921H133.706L124.402 130.49L124.509 130.631Z",
    fill: "#F5F5F5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 126.326)",
    stroke: "url(#paint22_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 126.326)",
    stroke: "url(#paint23_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 116.996C93.1595 122.316 96.5418 127.635 103.306 131.694C116.836 139.812 138.771 139.812 152.3 131.694C159.065 127.635 162.447 122.316 162.447 116.996V108.026C162.447 102.707 159.065 97.3871 152.3 93.3284C138.771 85.2109 116.836 85.2109 103.306 93.3284C96.5418 97.3871 93.1595 102.707 93.1595 108.026V116.996Z",
    fill: "url(#paint24_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 87,
    width: 70,
    height: 51
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 116.996C93.1595 122.316 96.5418 127.635 103.306 131.694C116.836 139.812 138.771 139.812 152.3 131.694C159.065 127.635 162.447 122.316 162.447 116.996V108.026C162.447 102.707 159.065 97.3871 152.3 93.3284C138.771 85.2109 116.836 85.2109 103.306 93.3284C96.5418 97.3871 93.1595 102.707 93.1595 108.026V116.996Z",
    fill: "url(#paint25_linear_2550_59381)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.604 112.277L122.138 111.707L125.786 125.387V137.813H105.038V120.257L118.604 112.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.522 120.142L136.151 116.152L141.062 124.018V137.812H130.333V125.781L128.522 120.142Z",
    fill: "#33B6FF"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 107.744)",
    fill: "#0F8BFB"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.202 103.393H128.106L128.213 103.534L129.932 105.801L127.739 107.349L124.88 103.621L125.202 103.393Z",
    fill: "#F5F5F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.106 103.393H125.202L124.88 103.621L115.738 110.102H118.908L128.213 103.534L128.106 103.393Z",
    fill: "#F5F5F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.412 111.631H124.509L124.402 111.49L122.682 109.222L124.875 107.674L127.734 111.402L127.412 111.631Z",
    fill: "#F5F5F5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.509 111.631H127.412L127.734 111.402L136.876 104.921H133.706L124.402 111.49L124.509 111.631Z",
    fill: "#F5F5F5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 107.326)",
    stroke: "url(#paint26_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 107.326)",
    stroke: "url(#paint27_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 99.9962C93.1595 105.316 96.5418 110.635 103.306 114.694C116.836 122.812 138.771 122.812 152.3 114.694C159.065 110.635 162.447 105.316 162.447 99.9962V91.0264C162.447 85.7068 159.065 80.3871 152.3 76.3284C138.771 68.2109 116.836 68.2109 103.306 76.3284C96.5418 80.3871 93.1595 85.7068 93.1595 91.0264V99.9962Z",
    fill: "url(#paint28_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 70,
    width: 70,
    height: 51
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1595 99.9962C93.1595 105.316 96.5418 110.635 103.306 114.694C116.836 122.812 138.771 122.812 152.3 114.694C159.065 110.635 162.447 105.316 162.447 99.9962V91.0264C162.447 85.7068 159.065 80.3871 152.3 76.3284C138.771 68.2109 116.836 68.2109 103.306 76.3284C96.5418 80.3871 93.1595 85.7068 93.1595 91.0264V99.9962Z",
    fill: "url(#paint29_linear_2550_59381)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.604 95.277L122.138 94.707L125.786 108.387V120.813H105.038V103.257L118.604 95.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.522 103.142L136.151 99.1523L141.062 107.018V120.812H130.333V108.781L128.522 103.142Z",
    fill: "#33B6FF"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 90.7441)",
    fill: "#0F8BFB"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.202 86.3926H128.106L128.213 86.5338L129.932 88.8011L127.739 90.3494L124.88 86.621L125.202 86.3926Z",
    fill: "#F5F5F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.106 86.3926H125.202L124.88 86.621L115.738 93.102H118.908L128.213 86.5338L128.106 86.3926Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.412 94.6309H124.509L124.402 94.4897L122.682 92.2223L124.875 90.674L127.734 94.4025L127.412 94.6309Z",
    fill: "#F5F5F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.509 94.6309H127.412L127.734 94.4025L136.876 87.9214H133.706L124.402 94.4897L124.509 94.6309Z",
    fill: "#F5F5F5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 90.3262)",
    stroke: "url(#paint30_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.803 90.3262)",
    stroke: "url(#paint31_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1595 88.9962C81.1595 94.3158 84.5418 99.6355 91.3064 103.694C104.836 111.812 126.771 111.812 140.3 103.694C147.065 99.6355 150.447 94.3158 150.447 88.9962V80.0264C150.447 74.7068 147.065 69.3871 140.3 65.3284C126.771 57.2109 104.836 57.2109 91.3064 65.3284C84.5418 69.3871 81.1595 74.7068 81.1595 80.0264V88.9962Z",
    fill: "url(#paint32_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 59,
    width: 70,
    height: 51
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1595 88.9962C81.1595 94.3158 84.5418 99.6355 91.3064 103.694C104.836 111.812 126.771 111.812 140.3 103.694C147.065 99.6355 150.447 94.3158 150.447 88.9962V80.0264C150.447 74.7068 147.065 69.3871 140.3 65.3284C126.771 57.2109 104.836 57.2109 91.3064 65.3284C84.5418 69.3871 81.1595 74.7068 81.1595 80.0264V88.9962Z",
    fill: "url(#paint33_linear_2550_59381)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.604 84.277L110.138 83.707L113.786 97.387V109.813H93.0381V92.257L106.604 84.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.522 92.1423L124.151 88.1523L129.062 96.0183V109.812H118.333V97.7811L116.522 92.1423Z",
    fill: "#33B6FF"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 115.803 79.7441)",
    fill: "#0F8BFB"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.41 75.391L117.924 76.8428L117.946 77.0186L118.302 79.842L115.628 80.0862L115.016 75.4277L115.41 75.391Z",
    fill: "#F5F5F5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.924 76.8428L115.41 75.391L115.016 75.4277L103.859 76.4695L106.604 78.0547L117.946 77.0186L117.924 76.8428Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.205 83.6305L110.69 82.1787L110.668 82.0029L110.312 79.1795L112.986 78.9353L113.598 83.5938L113.205 83.6305Z",
    fill: "#F5F5F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.69 82.1787L113.205 83.6305L113.598 83.5938L124.755 82.5519L122.01 80.9668L110.668 82.0029L110.69 82.1787Z",
    fill: "#F5F5F5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 115.803 79.3262)",
    stroke: "url(#paint34_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 115.803 79.3262)",
    stroke: "url(#paint35_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M139.429 142.261L140.186 141.955V142.411L139.637 142.627L139.429 142.261Z",
    fill: "#0B68BC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M116.944 143.233L116.13 143.016V143.47L116.758 143.639L116.944 143.233Z",
    fill: "#0B68BC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.011 145.134L127.652 144.295V144.75L127.858 145.217L128.011 145.134Z",
    fill: "#0B68BC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M113.05 100.151C110.719 100.709 110.629 99.9001 109.925 103.862C109.893 104.046 109.514 104.046 109.481 103.862C108.777 99.9001 108.683 100.709 106.356 100.151C106.152 100.102 106.152 99.8988 106.356 99.8499C108.687 99.2911 108.777 100.1 109.481 96.1389C109.514 95.9537 109.893 95.9537 109.925 96.1389C110.629 100.1 110.723 99.2911 113.05 99.8499C113.254 99.8988 113.254 100.102 113.05 100.151Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter28_f_2550_59381)"
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M195.703 170C210.891 170 223.203 175.82 223.203 183C223.203 190.18 210.891 196 195.703 196C180.515 196 168.203 190.18 168.203 183C168.203 175.82 180.515 170 195.703 170Z",
    fill: "#CCCCCC"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.16 171.996C161.16 177.316 164.542 182.635 171.306 186.694C184.836 194.812 206.771 194.812 220.3 186.694C227.065 182.635 230.447 177.316 230.447 171.996V163.026C230.447 157.707 227.065 152.387 220.3 148.328C206.771 140.211 184.836 140.211 171.306 148.328C164.542 152.387 161.16 157.707 161.16 163.026V171.996Z",
    fill: "url(#paint36_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 142,
    width: 70,
    height: 51
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.16 171.996C161.16 177.316 164.542 182.635 171.306 186.694C184.836 194.812 206.771 194.812 220.3 186.694C227.065 182.635 230.447 177.316 230.447 171.996V163.026C230.447 157.707 227.065 152.387 220.3 148.328C206.771 140.211 184.836 140.211 171.306 148.328C164.542 152.387 161.16 157.707 161.16 163.026V171.996Z",
    fill: "url(#paint37_linear_2550_59381)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.604 167.277L190.138 166.707L193.786 180.387V192.813H173.038V175.257L186.604 167.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.522 175.142L204.151 171.152L209.062 179.018V192.812H198.333V180.781L196.522 175.142Z",
    fill: "#33B6FF"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 195.803 162.744)",
    fill: "#0F8BFB"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.202 158.393H196.106L196.213 158.534L197.932 160.801L195.739 162.349L192.88 158.621L193.202 158.393Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.106 158.393H193.202L192.88 158.621L183.738 165.102H186.908L196.213 158.534L196.106 158.393Z",
    fill: "#F5F5F5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.412 166.631H192.509L192.402 166.49L190.682 164.222L192.875 162.674L195.734 166.402L195.412 166.631Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.509 166.631H195.412L195.734 166.402L204.876 159.921H201.706L192.402 166.49L192.509 166.631Z",
    fill: "#F5F5F5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 195.803 162.326)",
    stroke: "url(#paint38_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 195.803 162.326)",
    stroke: "url(#paint39_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M201.429 162.261L202.186 161.955V162.411L201.637 162.627L201.429 162.261Z",
    fill: "#0B68BC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M212.954 163.544L213.707 163.236V163.692L213.158 163.916L212.954 163.544Z",
    fill: "#0B68BC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M178.944 163.233L178.13 163.016V163.47L178.758 163.639L178.944 163.233Z",
    fill: "#0B68BC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M190.011 165.134L189.652 164.295V164.75L189.858 165.217L190.011 165.134Z",
    fill: "#0B68BC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.16 155.996C162.16 161.316 165.542 166.635 172.306 170.694C185.836 178.812 207.771 178.812 221.3 170.694C228.065 166.635 231.447 161.316 231.447 155.996V147.026C231.447 141.707 228.065 136.387 221.3 132.328C207.771 124.211 185.836 124.211 172.306 132.328C165.542 136.387 162.16 141.707 162.16 147.026V155.996Z",
    fill: "url(#paint40_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 126,
    width: 70,
    height: 51
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.16 155.996C162.16 161.316 165.542 166.635 172.306 170.694C185.836 178.812 207.771 178.812 221.3 170.694C228.065 166.635 231.447 161.316 231.447 155.996V147.026C231.447 141.707 228.065 136.387 221.3 132.328C207.771 124.211 185.836 124.211 172.306 132.328C165.542 136.387 162.16 141.707 162.16 147.026V155.996Z",
    fill: "url(#paint41_linear_2550_59381)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.604 151.277L191.138 150.707L194.786 164.387V176.813H174.038V159.257L187.604 151.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.522 159.142L205.151 155.152L210.062 163.018V176.812H199.333V164.781L197.522 159.142Z",
    fill: "#33B6FF"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 146.744)",
    fill: "#0F8BFB"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.202 142.393H197.106L197.213 142.534L198.932 144.801L196.739 146.349L193.88 142.621L194.202 142.393Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.106 142.393H194.202L193.88 142.621L184.738 149.102H187.908L197.213 142.534L197.106 142.393Z",
    fill: "#F5F5F5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.412 150.631H193.509L193.402 150.49L191.682 148.222L193.875 146.674L196.734 150.402L196.412 150.631Z",
    fill: "#F5F5F5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.509 150.631H196.412L196.734 150.402L205.876 143.921H202.706L193.402 150.49L193.509 150.631Z",
    fill: "#F5F5F5"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 146.326)",
    stroke: "url(#paint42_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 146.326)",
    stroke: "url(#paint43_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M202.429 146.261L203.186 145.955V146.411L202.637 146.627L202.429 146.261Z",
    fill: "#0B68BC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M213.954 147.544L214.707 147.236V147.692L214.158 147.916L213.954 147.544Z",
    fill: "#0B68BC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M179.944 147.233L179.13 147.016V147.47L179.758 147.639L179.944 147.233Z",
    fill: "#0B68BC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M191.011 149.134L190.652 148.295V148.75L190.858 149.217L191.011 149.134Z",
    fill: "#0B68BC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.16 136.996C162.16 142.316 165.542 147.635 172.306 151.694C185.836 159.812 207.771 159.812 221.3 151.694C228.065 147.635 231.447 142.316 231.447 136.996V128.026C231.447 122.707 228.065 117.387 221.3 113.328C207.771 105.211 185.836 105.211 172.306 113.328C165.542 117.387 162.16 122.707 162.16 128.026V136.996Z",
    fill: "url(#paint44_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 107,
    width: 70,
    height: 51
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.16 136.996C162.16 142.316 165.542 147.635 172.306 151.694C185.836 159.812 207.771 159.812 221.3 151.694C228.065 147.635 231.447 142.316 231.447 136.996V128.026C231.447 122.707 228.065 117.387 221.3 113.328C207.771 105.211 185.836 105.211 172.306 113.328C165.542 117.387 162.16 122.707 162.16 128.026V136.996Z",
    fill: "url(#paint45_linear_2550_59381)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.604 132.277L191.138 131.707L194.786 145.387V157.813H174.038V140.257L187.604 132.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.522 140.142L205.151 136.152L210.062 144.018V157.812H199.333V145.781L197.522 140.142Z",
    fill: "#33B6FF"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 127.744)",
    fill: "#0F8BFB"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.202 123.393H197.106L197.213 123.534L198.932 125.801L196.739 127.349L193.88 123.621L194.202 123.393Z",
    fill: "#F5F5F5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.106 123.393H194.202L193.88 123.621L184.738 130.102H187.908L197.213 123.534L197.106 123.393Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.412 131.631H193.509L193.402 131.49L191.682 129.222L193.875 127.674L196.734 131.402L196.412 131.631Z",
    fill: "#F5F5F5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.509 131.631H196.412L196.734 131.402L205.876 124.921H202.706L193.402 131.49L193.509 131.631Z",
    fill: "#F5F5F5"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 127.326)",
    stroke: "url(#paint46_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 127.326)",
    stroke: "url(#paint47_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M202.429 127.261L203.186 126.955V127.411L202.637 127.627L202.429 127.261Z",
    fill: "#0B68BC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M213.954 128.544L214.707 128.236V128.692L214.158 128.916L213.954 128.544Z",
    fill: "#0B68BC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M179.944 128.233L179.13 128.016V128.47L179.758 128.639L179.944 128.233Z",
    fill: "#0B68BC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M191.011 130.134L190.652 129.295V129.75L190.858 130.217L191.011 130.134Z",
    fill: "#0B68BC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.16 120.996C162.16 126.316 165.542 131.635 172.306 135.694C185.836 143.812 207.771 143.812 221.3 135.694C228.065 131.635 231.447 126.316 231.447 120.996V112.026C231.447 106.707 228.065 101.387 221.3 97.3284C207.771 89.2109 185.836 89.2109 172.306 97.3284C165.542 101.387 162.16 106.707 162.16 112.026V120.996Z",
    fill: "url(#paint48_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 91,
    width: 70,
    height: 51
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.16 120.996C162.16 126.316 165.542 131.635 172.306 135.694C185.836 143.812 207.771 143.812 221.3 135.694C228.065 131.635 231.447 126.316 231.447 120.996V112.026C231.447 106.707 228.065 101.387 221.3 97.3284C207.771 89.2109 185.836 89.2109 172.306 97.3284C165.542 101.387 162.16 106.707 162.16 112.026V120.996Z",
    fill: "url(#paint49_linear_2550_59381)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.604 116.277L191.138 115.707L194.786 129.387V141.813H174.038V124.257L187.604 116.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.522 124.142L205.151 120.152L210.062 128.018V141.812H199.333V129.781L197.522 124.142Z",
    fill: "#33B6FF"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 111.744)",
    fill: "#0F8BFB"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.202 107.393H197.106L197.213 107.534L198.932 109.801L196.739 111.349L193.88 107.621L194.202 107.393Z",
    fill: "#F5F5F5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.106 107.393H194.202L193.88 107.621L184.738 114.102H187.908L197.213 107.534L197.106 107.393Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.412 115.631H193.509L193.402 115.49L191.682 113.222L193.875 111.674L196.734 115.402L196.412 115.631Z",
    fill: "#F5F5F5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.509 115.631H196.412L196.734 115.402L205.876 108.921H202.706L193.402 115.49L193.509 115.631Z",
    fill: "#F5F5F5"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 111.326)",
    stroke: "url(#paint50_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 196.803 111.326)",
    stroke: "url(#paint51_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M202.429 111.261L203.186 110.955V111.411L202.637 111.627L202.429 111.261Z",
    fill: "#0B68BC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M213.954 112.544L214.707 112.236V112.692L214.158 112.916L213.954 112.544Z",
    fill: "#0B68BC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M179.944 112.233L179.13 112.016V112.47L179.758 112.639L179.944 112.233Z",
    fill: "#0B68BC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M191.011 114.134L190.652 113.295V113.75L190.858 114.217L191.011 114.134Z",
    fill: "#0B68BC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 104.996C163.16 110.316 166.542 115.635 173.306 119.694C186.836 127.812 208.771 127.812 222.3 119.694C229.065 115.635 232.447 110.316 232.447 104.996V96.0264C232.447 90.7068 229.065 85.3871 222.3 81.3284C208.771 73.2109 186.836 73.2109 173.306 81.3284C166.542 85.3871 163.16 90.7068 163.16 96.0264V104.996Z",
    fill: "url(#paint52_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 75,
    width: 70,
    height: 51
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 104.996C163.16 110.316 166.542 115.635 173.306 119.694C186.836 127.812 208.771 127.812 222.3 119.694C229.065 115.635 232.447 110.316 232.447 104.996V96.0264C232.447 90.7068 229.065 85.3871 222.3 81.3284C208.771 73.2109 186.836 73.2109 173.306 81.3284C166.542 85.3871 163.16 90.7068 163.16 96.0264V104.996Z",
    fill: "url(#paint53_linear_2550_59381)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.604 100.277L192.138 99.707L195.786 113.387V125.813H175.038V108.257L188.604 100.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.522 108.142L206.151 104.152L211.062 112.018V125.812H200.333V113.781L198.522 108.142Z",
    fill: "#33B6FF"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 95.7441)",
    fill: "#0F8BFB"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.202 91.3926H198.106L198.213 91.5338L199.932 93.8011L197.739 95.3494L194.88 91.621L195.202 91.3926Z",
    fill: "#F5F5F5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.106 91.3926H195.202L194.88 91.621L185.738 98.102H188.908L198.213 91.5338L198.106 91.3926Z",
    fill: "#F5F5F5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.412 99.6309H194.509L194.402 99.4897L192.682 97.2223L194.875 95.674L197.734 99.4025L197.412 99.6309Z",
    fill: "#F5F5F5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.509 99.6309H197.412L197.734 99.4025L206.876 92.9214H203.706L194.402 99.4897L194.509 99.6309Z",
    fill: "#F5F5F5"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 95.3262)",
    stroke: "url(#paint54_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 95.3262)",
    stroke: "url(#paint55_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 87.9962C163.16 93.3158 166.542 98.6355 173.306 102.694C186.836 110.812 208.771 110.812 222.3 102.694C229.065 98.6355 232.447 93.3158 232.447 87.9962V79.0264C232.447 73.7068 229.065 68.3871 222.3 64.3284C208.771 56.2109 186.836 56.2109 173.306 64.3284C166.542 68.3871 163.16 73.7068 163.16 79.0264V87.9962Z",
    fill: "url(#paint56_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 58,
    width: 70,
    height: 51
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 87.9962C163.16 93.3158 166.542 98.6355 173.306 102.694C186.836 110.812 208.771 110.812 222.3 102.694C229.065 98.6355 232.447 93.3158 232.447 87.9962V79.0264C232.447 73.7068 229.065 68.3871 222.3 64.3284C208.771 56.2109 186.836 56.2109 173.306 64.3284C166.542 68.3871 163.16 73.7068 163.16 79.0264V87.9962Z",
    fill: "url(#paint57_linear_2550_59381)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.604 83.277L192.138 82.707L195.786 96.387V108.813H175.038V91.257L188.604 83.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.522 91.1423L206.151 87.1523L211.062 95.0183V108.812H200.333V96.7811L198.522 91.1423Z",
    fill: "#33B6FF"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 78.7441)",
    fill: "#0F8BFB"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.202 74.3926H198.106L198.213 74.5338L199.932 76.8011L197.739 78.3494L194.88 74.621L195.202 74.3926Z",
    fill: "#F5F5F5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.106 74.3926H195.202L194.88 74.621L185.738 81.102H188.908L198.213 74.5338L198.106 74.3926Z",
    fill: "#F5F5F5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.412 82.6309H194.509L194.402 82.4897L192.682 80.2223L194.875 78.674L197.734 82.4025L197.412 82.6309Z",
    fill: "#F5F5F5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.509 82.6309H197.412L197.734 82.4025L206.876 75.9214H203.706L194.402 82.4897L194.509 82.6309Z",
    fill: "#F5F5F5"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 78.3262)",
    stroke: "url(#paint58_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 78.3262)",
    stroke: "url(#paint59_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 68.9962C163.16 74.3158 166.542 79.6355 173.306 83.6942C186.836 91.8117 208.771 91.8117 222.3 83.6942C229.065 79.6355 232.447 74.3158 232.447 68.9962V60.0264C232.447 54.7068 229.065 49.3871 222.3 45.3284C208.771 37.2109 186.836 37.2109 173.306 45.3284C166.542 49.3871 163.16 54.7068 163.16 60.0264V68.9962Z",
    fill: "url(#paint60_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 39,
    width: 70,
    height: 51
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 68.9962C163.16 74.3158 166.542 79.6355 173.306 83.6942C186.836 91.8117 208.771 91.8117 222.3 83.6942C229.065 79.6355 232.447 74.3158 232.447 68.9962V60.0264C232.447 54.7068 229.065 49.3871 222.3 45.3284C208.771 37.2109 186.836 37.2109 173.306 45.3284C166.542 49.3871 163.16 54.7068 163.16 60.0264V68.9962Z",
    fill: "url(#paint61_linear_2550_59381)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.604 64.277L192.138 63.707L195.786 77.387V89.813H175.038V72.257L188.604 64.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.522 72.1423L206.151 68.1523L211.062 76.0183V89.8123H200.333V77.7811L198.522 72.1423Z",
    fill: "#33B6FF"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 59.7441)",
    fill: "#0F8BFB"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.202 55.3926H198.106L198.213 55.5338L199.932 57.8011L197.739 59.3494L194.88 55.621L195.202 55.3926Z",
    fill: "#F5F5F5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.106 55.3926H195.202L194.88 55.621L185.738 62.102H188.908L198.213 55.5338L198.106 55.3926Z",
    fill: "#F5F5F5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.412 63.6309H194.509L194.402 63.4897L192.682 61.2223L194.875 59.674L197.734 63.4025L197.412 63.6309Z",
    fill: "#F5F5F5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.509 63.6309H197.412L197.734 63.4025L206.876 56.9214H203.706L194.402 63.4897L194.509 63.6309Z",
    fill: "#F5F5F5"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 59.3262)",
    stroke: "url(#paint62_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 59.3262)",
    stroke: "url(#paint63_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 51.9962C163.16 57.3158 166.542 62.6355 173.306 66.6942C186.836 74.8117 208.771 74.8117 222.3 66.6942C229.065 62.6355 232.447 57.3158 232.447 51.9962V43.0264C232.447 37.7068 229.065 32.3871 222.3 28.3284C208.771 20.2109 186.836 20.2109 173.306 28.3284C166.542 32.3871 163.16 37.7068 163.16 43.0264V51.9962Z",
    fill: "url(#paint64_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 22,
    width: 70,
    height: 51
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.16 51.9962C163.16 57.3158 166.542 62.6355 173.306 66.6942C186.836 74.8117 208.771 74.8117 222.3 66.6942C229.065 62.6355 232.447 57.3158 232.447 51.9962V43.0264C232.447 37.7068 229.065 32.3871 222.3 28.3284C208.771 20.2109 186.836 20.2109 173.306 28.3284C166.542 32.3871 163.16 37.7068 163.16 43.0264V51.9962Z",
    fill: "url(#paint65_linear_2550_59381)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.604 47.277L192.138 46.707L195.786 60.387V72.813H175.038V55.257L188.604 47.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.522 55.1423L206.151 51.1523L211.062 59.0183V72.8123H200.333V60.7811L198.522 55.1423Z",
    fill: "#33B6FF"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 42.7441)",
    fill: "#0F8BFB"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.202 38.3926H198.106L198.213 38.5338L199.932 40.8011L197.739 42.3494L194.88 38.621L195.202 38.3926Z",
    fill: "#F5F5F5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.106 38.3926H195.202L194.88 38.621L185.738 45.102H188.908L198.213 38.5338L198.106 38.3926Z",
    fill: "#F5F5F5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.412 46.6309H194.509L194.402 46.4897L192.682 44.2223L194.875 42.674L197.734 46.4025L197.412 46.6309Z",
    fill: "#F5F5F5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.509 46.6309H197.412L197.734 46.4025L206.876 39.9214H203.706L194.402 46.4897L194.509 46.6309Z",
    fill: "#F5F5F5"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 42.3262)",
    stroke: "url(#paint66_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 197.803 42.3262)",
    stroke: "url(#paint67_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.16 35.9962C172.16 41.3158 175.542 46.6355 182.306 50.6942C195.836 58.8117 217.771 58.8117 231.3 50.6942C238.065 46.6355 241.447 41.3158 241.447 35.9962V27.0264C241.447 21.7068 238.065 16.3871 231.3 12.3284C217.771 4.21086 195.836 4.21086 182.306 12.3284C175.542 16.3871 172.16 21.7068 172.16 27.0264V35.9962Z",
    fill: "url(#paint68_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 6,
    width: 70,
    height: 51
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.16 35.9962C172.16 41.3158 175.542 46.6355 182.306 50.6942C195.836 58.8117 217.771 58.8117 231.3 50.6942C238.065 46.6355 241.447 41.3158 241.447 35.9962V27.0264C241.447 21.7068 238.065 16.3871 231.3 12.3284C217.771 4.21086 195.836 4.21086 182.306 12.3284C175.542 16.3871 172.16 21.7068 172.16 27.0264V35.9962Z",
    fill: "url(#paint69_linear_2550_59381)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.604 31.277L201.138 30.707L204.786 44.387V56.813H184.038V39.257L197.604 31.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.522 39.1423L215.151 35.1523L220.062 43.0183V56.8123H209.333V44.7811L207.522 39.1423Z",
    fill: "#33B6FF"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 206.803 26.7441)",
    fill: "#0F8BFB"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.202 22.3926H207.106L207.213 22.5338L208.932 24.8011L206.739 26.3494L203.88 22.621L204.202 22.3926Z",
    fill: "#F5F5F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.106 22.3926H204.202L203.88 22.621L194.738 29.102H197.908L207.213 22.5338L207.106 22.3926Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.412 30.6309H203.509L203.402 30.4897L201.682 28.2223L203.875 26.674L206.734 30.4025L206.412 30.6309Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.509 30.6309H206.412L206.734 30.4025L215.876 23.9214H212.706L203.402 30.4897L203.509 30.6309Z",
    fill: "#F5F5F5"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 206.803 26.3262)",
    stroke: "url(#paint70_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 206.803 26.3262)",
    stroke: "url(#paint71_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M209.429 94.2609L210.186 93.9551V94.4111L209.637 94.6271L209.429 94.2609Z",
    fill: "#0B68BC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M186.944 95.2329L186.13 95.0156V95.4702L186.758 95.6389L186.944 95.2329Z",
    fill: "#0B68BC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M198.011 97.134L197.652 96.2949V96.7495L197.858 97.2174L198.011 97.134Z",
    fill: "#0B68BC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05 39.1506C197.719 39.7094 197.629 38.9001 196.925 42.8616C196.893 43.0461 196.514 43.0461 196.481 42.8616C195.777 38.9001 195.683 39.7094 193.356 39.1506C193.152 39.1016 193.152 38.8988 193.356 38.8499C195.687 38.2911 195.777 39.0997 196.481 35.1389C196.514 34.9537 196.893 34.9537 196.925 35.1389C197.629 39.0997 197.723 38.2911 200.05 38.8499C200.254 38.8988 200.254 39.1016 200.05 39.1506Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter56_f_2550_59381)"
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M187.203 287C205.981 287 221.203 292.82 221.203 300C221.203 307.18 205.981 313 187.203 313C168.425 313 153.203 307.18 153.203 300C153.203 292.82 168.425 287 187.203 287Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter57_f_2550_59381)"
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M177.703 260C192.891 260 205.203 265.82 205.203 273C205.203 280.18 192.891 286 177.703 286C162.515 286 150.203 280.18 150.203 273C150.203 265.82 162.515 260 177.703 260Z",
    fill: "#CCCCCC"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.16 261.996C143.16 267.316 146.542 272.635 153.306 276.694C166.836 284.812 188.771 284.812 202.3 276.694C209.065 272.635 212.447 267.316 212.447 261.996V253.026C212.447 247.707 209.065 242.387 202.3 238.328C188.771 230.211 166.836 230.211 153.306 238.328C146.542 242.387 143.16 247.707 143.16 253.026V261.996Z",
    fill: "url(#paint72_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 232,
    width: 70,
    height: 51
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.16 261.996C143.16 267.316 146.542 272.635 153.306 276.694C166.836 284.812 188.771 284.812 202.3 276.694C209.065 272.635 212.447 267.316 212.447 261.996V253.026C212.447 247.707 209.065 242.387 202.3 238.328C188.771 230.211 166.836 230.211 153.306 238.328C146.542 242.387 143.16 247.707 143.16 253.026V261.996Z",
    fill: "url(#paint73_linear_2550_59381)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.604 257.277L172.138 256.707L175.786 270.387V282.813H155.038V265.257L168.604 257.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.522 265.142L186.151 261.152L191.062 269.018V282.812H180.333V270.781L178.522 265.142Z",
    fill: "#33B6FF"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 177.803 252.744)",
    fill: "#0F8BFB"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.202 248.393H178.106L178.213 248.534L179.932 250.801L177.739 252.349L174.88 248.621L175.202 248.393Z",
    fill: "#F5F5F5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.106 248.393H175.202L174.88 248.621L165.738 255.102H168.908L178.213 248.534L178.106 248.393Z",
    fill: "#F5F5F5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.412 256.631H174.509L174.402 256.49L172.682 254.222L174.875 252.674L177.734 256.402L177.412 256.631Z",
    fill: "#F5F5F5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.509 256.631H177.412L177.734 256.402L186.876 249.921H183.706L174.402 256.49L174.509 256.631Z",
    fill: "#F5F5F5"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 177.803 252.326)",
    stroke: "url(#paint74_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 177.803 252.326)",
    stroke: "url(#paint75_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M183.429 252.261L184.186 251.955V252.411L183.637 252.627L183.429 252.261Z",
    fill: "#0B68BC"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M160.944 253.233L160.13 253.016V253.47L160.758 253.639L160.944 253.233Z",
    fill: "#0B68BC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M172.011 255.134L171.652 254.295V254.75L171.858 255.217L172.011 255.134Z",
    fill: "#0B68BC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.16 245.996C144.16 251.316 147.542 256.635 154.306 260.694C167.836 268.812 189.771 268.812 203.3 260.694C210.065 256.635 213.447 251.316 213.447 245.996V237.026C213.447 231.707 210.065 226.387 203.3 222.328C189.771 214.211 167.836 214.211 154.306 222.328C147.542 226.387 144.16 231.707 144.16 237.026V245.996Z",
    fill: "url(#paint76_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 216,
    width: 70,
    height: 51
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.16 245.996C144.16 251.316 147.542 256.635 154.306 260.694C167.836 268.812 189.771 268.812 203.3 260.694C210.065 256.635 213.447 251.316 213.447 245.996V237.026C213.447 231.707 210.065 226.387 203.3 222.328C189.771 214.211 167.836 214.211 154.306 222.328C147.542 226.387 144.16 231.707 144.16 237.026V245.996Z",
    fill: "url(#paint77_linear_2550_59381)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.604 241.277L173.138 240.707L176.786 254.387V266.813H156.038V249.257L169.604 241.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.522 249.142L187.151 245.152L192.062 253.018V266.812H181.333V254.781L179.522 249.142Z",
    fill: "#33B6FF"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 236.744)",
    fill: "#0F8BFB"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.202 232.393H179.106L179.213 232.534L180.932 234.801L178.739 236.349L175.88 232.621L176.202 232.393Z",
    fill: "#F5F5F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.106 232.393H176.202L175.88 232.621L166.738 239.102H169.908L179.213 232.534L179.106 232.393Z",
    fill: "#F5F5F5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.412 240.631H175.509L175.402 240.49L173.682 238.222L175.875 236.674L178.734 240.402L178.412 240.631Z",
    fill: "#F5F5F5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.509 240.631H178.412L178.734 240.402L187.876 233.921H184.706L175.402 240.49L175.509 240.631Z",
    fill: "#F5F5F5"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 236.326)",
    stroke: "url(#paint78_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 236.326)",
    stroke: "url(#paint79_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M184.429 236.261L185.186 235.955V236.411L184.637 236.627L184.429 236.261Z",
    fill: "#0B68BC"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M161.944 237.233L161.13 237.016V237.47L161.758 237.639L161.944 237.233Z",
    fill: "#0B68BC"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M173.011 239.134L172.652 238.295V238.75L172.858 239.217L173.011 239.134Z",
    fill: "#0B68BC"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.16 226.996C144.16 232.316 147.542 237.635 154.306 241.694C167.836 249.812 189.771 249.812 203.3 241.694C210.065 237.635 213.447 232.316 213.447 226.996V218.026C213.447 212.707 210.065 207.387 203.3 203.328C189.771 195.211 167.836 195.211 154.306 203.328C147.542 207.387 144.16 212.707 144.16 218.026V226.996Z",
    fill: "url(#paint80_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 197,
    width: 70,
    height: 51
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.16 226.996C144.16 232.316 147.542 237.635 154.306 241.694C167.836 249.812 189.771 249.812 203.3 241.694C210.065 237.635 213.447 232.316 213.447 226.996V218.026C213.447 212.707 210.065 207.387 203.3 203.328C189.771 195.211 167.836 195.211 154.306 203.328C147.542 207.387 144.16 212.707 144.16 218.026V226.996Z",
    fill: "url(#paint81_linear_2550_59381)"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.604 222.277L173.138 221.707L176.786 235.387V247.813H156.038V230.257L169.604 222.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.522 230.142L187.151 226.152L192.062 234.018V247.812H181.333V235.781L179.522 230.142Z",
    fill: "#33B6FF"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 217.744)",
    fill: "#0F8BFB"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.202 213.393H179.106L179.213 213.534L180.932 215.801L178.739 217.349L175.88 213.621L176.202 213.393Z",
    fill: "#F5F5F5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.106 213.393H176.202L175.88 213.621L166.738 220.102H169.908L179.213 213.534L179.106 213.393Z",
    fill: "#F5F5F5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.412 221.631H175.509L175.402 221.49L173.682 219.222L175.875 217.674L178.734 221.402L178.412 221.631Z",
    fill: "#F5F5F5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.509 221.631H178.412L178.734 221.402L187.876 214.921H184.706L175.402 221.49L175.509 221.631Z",
    fill: "#F5F5F5"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 217.326)",
    stroke: "url(#paint82_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 217.326)",
    stroke: "url(#paint83_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M184.429 217.261L185.186 216.955V217.411L184.637 217.627L184.429 217.261Z",
    fill: "#0B68BC"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M161.944 218.233L161.13 218.016V218.47L161.758 218.639L161.944 218.233Z",
    fill: "#0B68BC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M173.011 220.134L172.652 219.295V219.75L172.858 220.217L173.011 220.134Z",
    fill: "#0B68BC"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.16 210.996C144.16 216.316 147.542 221.635 154.306 225.694C167.836 233.812 189.771 233.812 203.3 225.694C210.065 221.635 213.447 216.316 213.447 210.996V202.026C213.447 196.707 210.065 191.387 203.3 187.328C189.771 179.211 167.836 179.211 154.306 187.328C147.542 191.387 144.16 196.707 144.16 202.026V210.996Z",
    fill: "url(#paint84_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 181,
    width: 70,
    height: 51
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.16 210.996C144.16 216.316 147.542 221.635 154.306 225.694C167.836 233.812 189.771 233.812 203.3 225.694C210.065 221.635 213.447 216.316 213.447 210.996V202.026C213.447 196.707 210.065 191.387 203.3 187.328C189.771 179.211 167.836 179.211 154.306 187.328C147.542 191.387 144.16 196.707 144.16 202.026V210.996Z",
    fill: "url(#paint85_linear_2550_59381)"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.604 206.277L173.138 205.707L176.786 219.387V231.813H156.038V214.257L169.604 206.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.522 214.142L187.151 210.152L192.062 218.018V231.812H181.333V219.781L179.522 214.142Z",
    fill: "#33B6FF"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 201.744)",
    fill: "#0F8BFB"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.202 197.393H179.106L179.213 197.534L180.932 199.801L178.739 201.349L175.88 197.621L176.202 197.393Z",
    fill: "#F5F5F5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.106 197.393H176.202L175.88 197.621L166.738 204.102H169.908L179.213 197.534L179.106 197.393Z",
    fill: "#F5F5F5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.412 205.631H175.509L175.402 205.49L173.682 203.222L175.875 201.674L178.734 205.402L178.412 205.631Z",
    fill: "#F5F5F5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.509 205.631H178.412L178.734 205.402L187.876 198.921H184.706L175.402 205.49L175.509 205.631Z",
    fill: "#F5F5F5"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 201.326)",
    stroke: "url(#paint86_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 178.803 201.326)",
    stroke: "url(#paint87_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M184.429 201.261L185.186 200.955V201.411L184.637 201.627L184.429 201.261Z",
    fill: "#0B68BC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M161.944 202.233L161.13 202.016V202.47L161.758 202.639L161.944 202.233Z",
    fill: "#0B68BC"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M173.011 204.134L172.652 203.295V203.75L172.858 204.217L173.011 204.134Z",
    fill: "#0B68BC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.16 196.996C138.16 202.316 141.542 207.635 148.306 211.694C161.836 219.812 183.771 219.812 197.3 211.694C204.065 207.635 207.447 202.316 207.447 196.996V188.026C207.447 182.707 204.065 177.387 197.3 173.328C183.771 165.211 161.836 165.211 148.306 173.328C141.542 177.387 138.16 182.707 138.16 188.026V196.996Z",
    fill: "url(#paint88_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 167,
    width: 70,
    height: 51
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.16 196.996C138.16 202.316 141.542 207.635 148.306 211.694C161.836 219.812 183.771 219.812 197.3 211.694C204.065 207.635 207.447 202.316 207.447 196.996V188.026C207.447 182.707 204.065 177.387 197.3 173.328C183.771 165.211 161.836 165.211 148.306 173.328C141.542 177.387 138.16 182.707 138.16 188.026V196.996Z",
    fill: "url(#paint89_linear_2550_59381)"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.604 192.277L167.138 191.707L170.786 205.387V217.813H150.038V200.257L163.604 192.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.522 200.142L181.151 196.152L186.062 204.018V217.812H175.333V205.781L173.522 200.142Z",
    fill: "#33B6FF"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 172.803 187.744)",
    fill: "#0F8BFB"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.202 183.393H173.106L173.213 183.534L174.932 185.801L172.739 187.349L169.88 183.621L170.202 183.393Z",
    fill: "#F5F5F5"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.106 183.393H170.202L169.88 183.621L160.738 190.102H163.908L173.213 183.534L173.106 183.393Z",
    fill: "#F5F5F5"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.412 191.631H169.509L169.402 191.49L167.682 189.222L169.875 187.674L172.734 191.402L172.412 191.631Z",
    fill: "#F5F5F5"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.509 191.631H172.412L172.734 191.402L181.876 184.921H178.706L169.402 191.49L169.509 191.631Z",
    fill: "#F5F5F5"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 172.803 187.326)",
    stroke: "url(#paint90_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 172.803 187.326)",
    stroke: "url(#paint91_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.16 177.996C139.16 183.316 142.542 188.635 149.306 192.694C162.836 200.812 184.771 200.812 198.3 192.694C205.065 188.635 208.447 183.316 208.447 177.996V169.026C208.447 163.707 205.065 158.387 198.3 154.328C184.771 146.211 162.836 146.211 149.306 154.328C142.542 158.387 139.16 163.707 139.16 169.026V177.996Z",
    fill: "url(#paint92_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 148,
    width: 70,
    height: 51
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.16 177.996C139.16 183.316 142.542 188.635 149.306 192.694C162.836 200.812 184.771 200.812 198.3 192.694C205.065 188.635 208.447 183.316 208.447 177.996V169.026C208.447 163.707 205.065 158.387 198.3 154.328C184.771 146.211 162.836 146.211 149.306 154.328C142.542 158.387 139.16 163.707 139.16 169.026V177.996Z",
    fill: "url(#paint93_linear_2550_59381)"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.604 173.277L168.138 172.707L171.786 186.387V198.813H151.038V181.257L164.604 173.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.522 181.142L182.151 177.152L187.062 185.018V198.812H176.333V186.781L174.522 181.142Z",
    fill: "#33B6FF"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 173.803 168.744)",
    fill: "#0F8BFB"
  }))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.202 164.393H174.105L174.213 164.534L175.932 166.801L173.739 168.349L170.88 164.621L171.202 164.393Z",
    fill: "#F5F5F5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.105 164.393H171.202L170.88 164.621L161.738 171.102H164.908L174.213 164.534L174.105 164.393Z",
    fill: "#F5F5F5"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.412 172.631H170.509L170.402 172.49L168.682 170.222L170.875 168.674L173.734 172.402L173.412 172.631Z",
    fill: "#F5F5F5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.509 172.631H173.412L173.734 172.402L182.876 165.921H179.706L170.402 172.49L170.509 172.631Z",
    fill: "#F5F5F5"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 173.803 168.326)",
    stroke: "url(#paint94_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 173.803 168.326)",
    stroke: "url(#paint95_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M168.944 185.233L168.13 185.016V185.47L168.758 185.639L168.944 185.233Z",
    fill: "#0B68BC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M180.011 187.134L179.652 186.295V186.75L179.858 187.217L180.011 187.134Z",
    fill: "#0B68BC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter76_f_2550_59381)"
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7031 259C75.891 259 88.2031 264.82 88.2031 272C88.2031 279.18 75.891 285 60.7031 285C45.5153 285 33.2031 279.18 33.2031 272C33.2031 264.82 45.5153 259 60.7031 259Z",
    fill: "#CCCCCC"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1595 260.996C26.1595 266.316 29.5418 271.635 36.3064 275.694C49.8356 283.812 71.7707 283.812 85.2999 275.694C92.0645 271.635 95.4468 266.316 95.4468 260.996V252.026C95.4468 246.707 92.0645 241.387 85.2999 237.328C71.7707 229.211 49.8356 229.211 36.3064 237.328C29.5418 241.387 26.1595 246.707 26.1595 252.026V260.996Z",
    fill: "url(#paint96_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 231,
    width: 70,
    height: 51
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1595 260.996C26.1595 266.316 29.5418 271.635 36.3064 275.694C49.8356 283.812 71.7707 283.812 85.2999 275.694C92.0645 271.635 95.4468 266.316 95.4468 260.996V252.026C95.4468 246.707 92.0645 241.387 85.2999 237.328C71.7707 229.211 49.8356 229.211 36.3064 237.328C29.5418 241.387 26.1595 246.707 26.1595 252.026V260.996Z",
    fill: "url(#paint97_linear_2550_59381)"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6041 256.277L55.1381 255.707L58.7861 269.387V281.813H38.0381V264.257L51.6041 256.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5221 264.142L69.1506 260.152L74.062 268.018V281.812H63.3334V269.781L61.5221 264.142Z",
    fill: "#33B6FF"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 60.8031 251.744)",
    fill: "#0F8BFB"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2021 247.393H61.1056L61.2127 247.534L62.9324 249.801L60.7391 251.349L57.88 247.621L58.2021 247.393Z",
    fill: "#F5F5F5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1056 247.393H58.2021L57.88 247.621L48.7381 254.102H51.9084L61.2127 247.534L61.1056 247.393Z",
    fill: "#F5F5F5"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4123 255.631H57.5088L57.4017 255.49L55.682 253.222L57.8754 251.674L60.7345 255.402L60.4123 255.631Z",
    fill: "#F5F5F5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5088 255.631H60.4123L60.7345 255.402L69.8763 248.921H66.706L57.4017 255.49L57.5088 255.631Z",
    fill: "#F5F5F5"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 60.8031 251.326)",
    stroke: "url(#paint98_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 60.8032 251.326)",
    stroke: "url(#paint99_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4294 251.261L67.186 250.955V251.411L66.6373 251.627L66.4294 251.261Z",
    fill: "#0B68BC"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9437 252.233L43.1304 252.016V252.47L43.7583 252.639L43.9437 252.233Z",
    fill: "#0B68BC"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0106 254.134L54.6523 253.295V253.75L54.8576 254.217L55.0106 254.134Z",
    fill: "#0B68BC"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1595 244.996C27.1595 250.316 30.5418 255.635 37.3064 259.694C50.8356 267.812 72.7707 267.812 86.2999 259.694C93.0645 255.635 96.4468 250.316 96.4468 244.996V236.026C96.4468 230.707 93.0645 225.387 86.2999 221.328C72.7707 213.211 50.8356 213.211 37.3064 221.328C30.5418 225.387 27.1595 230.707 27.1595 236.026V244.996Z",
    fill: "url(#paint100_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 215,
    width: 70,
    height: 51
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1595 244.996C27.1595 250.316 30.5418 255.635 37.3064 259.694C50.8356 267.812 72.7707 267.812 86.2999 259.694C93.0645 255.635 96.4468 250.316 96.4468 244.996V236.026C96.4468 230.707 93.0645 225.387 86.2999 221.328C72.7707 213.211 50.8356 213.211 37.3064 221.328C30.5418 225.387 27.1595 230.707 27.1595 236.026V244.996Z",
    fill: "url(#paint101_linear_2550_59381)"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6041 240.277L56.1381 239.707L59.7861 253.387V265.813H39.0381V248.257L52.6041 240.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5221 248.142L70.1506 244.152L75.062 252.018V265.812H64.3334V253.781L62.5221 248.142Z",
    fill: "#33B6FF"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8031 235.744)",
    fill: "#0F8BFB"
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2021 231.393H62.1056L62.2127 231.534L63.9324 233.801L61.7391 235.349L58.88 231.621L59.2021 231.393Z",
    fill: "#F5F5F5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1056 231.393H59.2021L58.88 231.621L49.7381 238.102H52.9084L62.2127 231.534L62.1056 231.393Z",
    fill: "#F5F5F5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4123 239.631H58.5088L58.4017 239.49L56.682 237.222L58.8754 235.674L61.7345 239.402L61.4123 239.631Z",
    fill: "#F5F5F5"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5088 239.631H61.4123L61.7345 239.402L70.8763 232.921H67.706L58.4017 239.49L58.5088 239.631Z",
    fill: "#F5F5F5"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8031 235.326)",
    stroke: "url(#paint102_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8032 235.326)",
    stroke: "url(#paint103_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4294 235.261L68.186 234.955V235.411L67.6373 235.627L67.4294 235.261Z",
    fill: "#0B68BC"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9437 236.233L44.1304 236.016V236.47L44.7583 236.639L44.9437 236.233Z",
    fill: "#0B68BC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0106 238.134L55.6523 237.295V237.75L55.8576 238.217L56.0106 238.134Z",
    fill: "#0B68BC"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1595 225.996C27.1595 231.316 30.5418 236.635 37.3064 240.694C50.8356 248.812 72.7707 248.812 86.2999 240.694C93.0645 236.635 96.4468 231.316 96.4468 225.996V217.026C96.4468 211.707 93.0645 206.387 86.2999 202.328C72.7707 194.211 50.8356 194.211 37.3064 202.328C30.5418 206.387 27.1595 211.707 27.1595 217.026V225.996Z",
    fill: "url(#paint104_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 196,
    width: 70,
    height: 51
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1595 225.996C27.1595 231.316 30.5418 236.635 37.3064 240.694C50.8356 248.812 72.7707 248.812 86.2999 240.694C93.0645 236.635 96.4468 231.316 96.4468 225.996V217.026C96.4468 211.707 93.0645 206.387 86.2999 202.328C72.7707 194.211 50.8356 194.211 37.3064 202.328C30.5418 206.387 27.1595 211.707 27.1595 217.026V225.996Z",
    fill: "url(#paint105_linear_2550_59381)"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6041 221.277L56.1381 220.707L59.7861 234.387V246.813H39.0381V229.257L52.6041 221.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5221 229.142L70.1506 225.152L75.062 233.018V246.812H64.3334V234.781L62.5221 229.142Z",
    fill: "#33B6FF"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8031 216.744)",
    fill: "#0F8BFB"
  }))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2021 212.393H62.1056L62.2127 212.534L63.9324 214.801L61.7391 216.349L58.88 212.621L59.2021 212.393Z",
    fill: "#F5F5F5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1056 212.393H59.2021L58.88 212.621L49.7381 219.102H52.9084L62.2127 212.534L62.1056 212.393Z",
    fill: "#F5F5F5"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4123 220.631H58.5088L58.4017 220.49L56.682 218.222L58.8754 216.674L61.7345 220.402L61.4123 220.631Z",
    fill: "#F5F5F5"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5088 220.631H61.4123L61.7345 220.402L70.8763 213.921H67.706L58.4017 220.49L58.5088 220.631Z",
    fill: "#F5F5F5"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8031 216.326)",
    stroke: "url(#paint106_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8032 216.326)",
    stroke: "url(#paint107_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4294 216.261L68.186 215.955V216.411L67.6373 216.627L67.4294 216.261Z",
    fill: "#0B68BC"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9437 217.233L44.1304 217.016V217.47L44.7583 217.639L44.9437 217.233Z",
    fill: "#0B68BC"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0106 219.134L55.6523 218.295V218.75L55.8576 219.217L56.0106 219.134Z",
    fill: "#0B68BC"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1595 209.996C27.1595 215.316 30.5418 220.635 37.3064 224.694C50.8356 232.812 72.7707 232.812 86.2999 224.694C93.0645 220.635 96.4468 215.316 96.4468 209.996V201.026C96.4468 195.707 93.0645 190.387 86.2999 186.328C72.7707 178.211 50.8356 178.211 37.3064 186.328C30.5418 190.387 27.1595 195.707 27.1595 201.026V209.996Z",
    fill: "url(#paint108_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 180,
    width: 70,
    height: 51
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1595 209.996C27.1595 215.316 30.5418 220.635 37.3064 224.694C50.8356 232.812 72.7707 232.812 86.2999 224.694C93.0645 220.635 96.4468 215.316 96.4468 209.996V201.026C96.4468 195.707 93.0645 190.387 86.2999 186.328C72.7707 178.211 50.8356 178.211 37.3064 186.328C30.5418 190.387 27.1595 195.707 27.1595 201.026V209.996Z",
    fill: "url(#paint109_linear_2550_59381)"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6041 205.277L56.1381 204.707L59.7861 218.387V230.813H39.0381V213.257L52.6041 205.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5221 213.142L70.1506 209.152L75.062 217.018V230.812H64.3334V218.781L62.5221 213.142Z",
    fill: "#33B6FF"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8031 200.744)",
    fill: "#0F8BFB"
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2021 196.393H62.1056L62.2127 196.534L63.9324 198.801L61.7391 200.349L58.88 196.621L59.2021 196.393Z",
    fill: "#F5F5F5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1056 196.393H59.2021L58.88 196.621L49.7381 203.102H52.9084L62.2127 196.534L62.1056 196.393Z",
    fill: "#F5F5F5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4123 204.631H58.5088L58.4017 204.49L56.682 202.222L58.8754 200.674L61.7345 204.402L61.4123 204.631Z",
    fill: "#F5F5F5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5088 204.631H61.4123L61.7345 204.402L70.8763 197.921H67.706L58.4017 204.49L58.5088 204.631Z",
    fill: "#F5F5F5"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8031 200.326)",
    stroke: "url(#paint110_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 61.8032 200.326)",
    stroke: "url(#paint111_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4294 200.261L68.186 199.955V200.411L67.6373 200.627L67.4294 200.261Z",
    fill: "#0B68BC"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9437 201.233L44.1304 201.016V201.47L44.7583 201.639L44.9437 201.233Z",
    fill: "#0B68BC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0106 203.134L55.6523 202.295V202.75L55.8576 203.217L56.0106 203.134Z",
    fill: "#0B68BC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1595 195.996C30.1595 201.316 33.5418 206.635 40.3064 210.694C53.8356 218.812 75.7707 218.812 89.2999 210.694C96.0645 206.635 99.4468 201.316 99.4468 195.996V187.026C99.4468 181.707 96.0645 176.387 89.2999 172.328C75.7707 164.211 53.8356 164.211 40.3064 172.328C33.5418 176.387 30.1595 181.707 30.1595 187.026V195.996Z",
    fill: "url(#paint112_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 166,
    width: 70,
    height: 51
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1595 195.996C30.1595 201.316 33.5418 206.635 40.3064 210.694C53.8356 218.812 75.7707 218.812 89.2999 210.694C96.0645 206.635 99.4468 201.316 99.4468 195.996V187.026C99.4468 181.707 96.0645 176.387 89.2999 172.328C75.7707 164.211 53.8356 164.211 40.3064 172.328C33.5418 176.387 30.1595 181.707 30.1595 187.026V195.996Z",
    fill: "url(#paint113_linear_2550_59381)"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6041 191.277L59.1381 190.707L62.7861 204.387V216.813H42.0381V199.257L55.6041 191.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5221 199.142L73.1506 195.152L78.062 203.018V216.812H67.3334V204.781L65.5221 199.142Z",
    fill: "#33B6FF"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 64.8031 186.744)",
    fill: "#0F8BFB"
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2021 182.393H65.1056L65.2127 182.534L66.9324 184.801L64.7391 186.349L61.88 182.621L62.2021 182.393Z",
    fill: "#F5F5F5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1056 182.393H62.2021L61.88 182.621L52.7381 189.102H55.9084L65.2127 182.534L65.1056 182.393Z",
    fill: "#F5F5F5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4123 190.631H61.5088L61.4017 190.49L59.682 188.222L61.8754 186.674L64.7345 190.402L64.4123 190.631Z",
    fill: "#F5F5F5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5088 190.631H64.4123L64.7345 190.402L73.8763 183.921H70.706L61.4017 190.49L61.5088 190.631Z",
    fill: "#F5F5F5"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 64.8031 186.326)",
    stroke: "url(#paint114_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 64.8032 186.326)",
    stroke: "url(#paint115_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1595 176.996C31.1595 182.316 34.5418 187.635 41.3064 191.694C54.8356 199.812 76.7707 199.812 90.2999 191.694C97.0645 187.635 100.447 182.316 100.447 176.996V168.026C100.447 162.707 97.0645 157.387 90.2999 153.328C76.7707 145.211 54.8356 145.211 41.3064 153.328C34.5418 157.387 31.1595 162.707 31.1595 168.026V176.996Z",
    fill: "url(#paint116_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 147,
    width: 70,
    height: 51
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1595 176.996C31.1595 182.316 34.5418 187.635 41.3064 191.694C54.8356 199.812 76.7707 199.812 90.2999 191.694C97.0645 187.635 100.447 182.316 100.447 176.996V168.026C100.447 162.707 97.0645 157.387 90.2999 153.328C76.7707 145.211 54.8356 145.211 41.3064 153.328C34.5418 157.387 31.1595 162.707 31.1595 168.026V176.996Z",
    fill: "url(#paint117_linear_2550_59381)"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6041 172.277L60.1381 171.707L63.7861 185.387V197.813H43.0381V180.257L56.6041 172.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5221 180.142L74.1506 176.152L79.062 184.018V197.812H68.3334V185.781L66.5221 180.142Z",
    fill: "#33B6FF"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 65.8031 167.744)",
    fill: "#0F8BFB"
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2021 163.393H66.1056L66.2127 163.534L67.9324 165.801L65.7391 167.349L62.88 163.621L63.2021 163.393Z",
    fill: "#F5F5F5"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1056 163.393H63.2021L62.88 163.621L53.7381 170.102H56.9084L66.2127 163.534L66.1056 163.393Z",
    fill: "#F5F5F5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4123 171.631H62.5088L62.4017 171.49L60.682 169.222L62.8754 167.674L65.7345 171.402L65.4123 171.631Z",
    fill: "#F5F5F5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5088 171.631H65.4123L65.7345 171.402L74.8763 164.921H71.706L62.4017 171.49L62.5088 171.631Z",
    fill: "#F5F5F5"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 65.8031 167.326)",
    stroke: "url(#paint118_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 65.8032 167.326)",
    stroke: "url(#paint119_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9437 184.233L51.1304 184.016V184.47L51.7583 184.639L51.9437 184.233Z",
    fill: "#0B68BC"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0106 186.134L62.6523 185.295V185.75L62.8576 186.217L63.0106 186.134Z",
    fill: "#0B68BC"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0503 286.151C64.7192 286.709 64.6286 285.9 63.9253 289.862C63.8926 290.046 63.5142 290.046 63.4808 289.862C62.7775 285.9 62.6832 286.709 60.3565 286.151C60.152 286.102 60.152 285.899 60.3565 285.85C62.6868 285.291 62.7775 286.1 63.4808 282.139C63.5142 281.954 63.8926 281.954 63.9253 282.139C64.6286 286.1 64.7228 285.291 67.0503 285.85C67.2541 285.899 67.2541 286.102 67.0503 286.151Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0503 219.151C85.7192 219.709 85.6286 218.9 84.9253 222.862C84.8926 223.046 84.5142 223.046 84.4808 222.862C83.7775 218.9 83.6832 219.709 81.3565 219.151C81.152 219.102 81.152 218.899 81.3565 218.85C83.6868 218.291 83.7775 219.1 84.4808 215.139C84.5142 214.954 84.8926 214.954 84.9253 215.139C85.6286 219.1 85.7228 218.291 88.0503 218.85C88.2541 218.899 88.2541 219.102 88.0503 219.151Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M140.05 257.151C137.719 257.709 137.629 256.9 136.925 260.862C136.893 261.046 136.514 261.046 136.481 260.862C135.777 256.9 135.683 257.709 133.356 257.151C133.152 257.102 133.152 256.899 133.356 256.85C135.687 256.291 135.777 257.1 136.481 253.139C136.514 252.954 136.893 252.954 136.925 253.139C137.629 257.1 137.723 256.291 140.05 256.85C140.254 256.899 140.254 257.102 140.05 257.151Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M140.954 218.542L141.708 218.234V218.69L141.158 218.914L140.954 218.542Z",
    fill: "#0B68BC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter95_f_2550_59381)"
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M115.703 293C130.891 293 143.203 298.82 143.203 306C143.203 313.18 130.891 319 115.703 319C100.515 319 88.2031 313.18 88.2031 306C88.2031 298.82 100.515 293 115.703 293Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter96_f_2550_59381)"
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7031 290C87.891 290 100.203 295.82 100.203 303C100.203 310.18 87.891 316 72.7031 316C57.5153 316 45.2031 310.18 45.2031 303C45.2031 295.82 57.5153 290 72.7031 290Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter97_f_2550_59381)"
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M174.703 265C227.999 265 271.203 274.626 271.203 286.5C271.203 298.374 227.999 308 174.703 308C121.408 308 78.2031 298.374 78.2031 286.5C78.2031 274.626 121.408 265 174.703 265Z",
    fill: "#CCCCCC"
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1593 294.996C81.1593 300.316 84.5416 305.635 91.3062 309.694C104.835 317.812 126.771 317.812 140.3 309.694C147.064 305.635 150.447 300.316 150.447 294.996V286.026C150.447 280.707 147.064 275.387 140.3 271.328C126.771 263.211 104.835 263.211 91.3062 271.328C84.5416 275.387 81.1593 280.707 81.1593 286.026V294.996Z",
    fill: "url(#paint120_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 265,
    width: 70,
    height: 51
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1593 294.996C81.1593 300.316 84.5416 305.635 91.3062 309.694C104.835 317.812 126.771 317.812 140.3 309.694C147.064 305.635 150.447 300.316 150.447 294.996V286.026C150.447 280.707 147.064 275.387 140.3 271.328C126.771 263.211 104.835 263.211 91.3062 271.328C84.5416 275.387 81.1593 280.707 81.1593 286.026V294.996Z",
    fill: "url(#paint121_linear_2550_59381)"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.604 290.277L110.138 289.707L113.786 303.387V315.813H93.038V298.257L106.604 290.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.522 298.142L124.15 294.152L129.062 302.018V315.812H118.333V303.781L116.522 298.142Z",
    fill: "#33B6FF"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 115.803 285.744)",
    fill: "#0F8BFB"
  }))), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.202 281.393H116.105L116.213 281.534L117.932 283.801L115.739 285.349L112.88 281.621L113.202 281.393Z",
    fill: "#F5F5F5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.105 281.393H113.202L112.88 281.621L103.738 288.102H106.908L116.213 281.534L116.105 281.393Z",
    fill: "#F5F5F5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.412 289.631H112.509L112.402 289.49L110.682 287.222L112.875 285.674L115.734 289.402L115.412 289.631Z",
    fill: "#F5F5F5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.509 289.631H115.412L115.734 289.402L124.876 282.921H121.706L112.402 289.49L112.509 289.631Z",
    fill: "#F5F5F5"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 115.803 285.326)",
    stroke: "url(#paint122_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 115.803 285.326)",
    stroke: "url(#paint123_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M121.429 285.261L122.186 284.955V285.411L121.637 285.627L121.429 285.261Z",
    fill: "#0B68BC"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M132.954 286.544L133.707 286.236V286.692L133.158 286.916L132.954 286.544Z",
    fill: "#0B68BC"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9435 286.233L98.1302 286.016V286.47L98.7581 286.639L98.9435 286.233Z",
    fill: "#0B68BC"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M110.01 288.134L109.652 287.295V287.75L109.857 288.217L110.01 288.134Z",
    fill: "#0B68BC"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1593 278.996C82.1593 284.316 85.5416 289.635 92.3062 293.694C105.835 301.812 127.771 301.812 141.3 293.694C148.064 289.635 151.447 284.316 151.447 278.996V270.026C151.447 264.707 148.064 259.387 141.3 255.328C127.771 247.211 105.835 247.211 92.3062 255.328C85.5416 259.387 82.1593 264.707 82.1593 270.026V278.996Z",
    fill: "url(#paint124_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 249,
    width: 70,
    height: 51
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1593 278.996C82.1593 284.316 85.5416 289.635 92.3062 293.694C105.835 301.812 127.771 301.812 141.3 293.694C148.064 289.635 151.447 284.316 151.447 278.996V270.026C151.447 264.707 148.064 259.387 141.3 255.328C127.771 247.211 105.835 247.211 92.3062 255.328C85.5416 259.387 82.1593 264.707 82.1593 270.026V278.996Z",
    fill: "url(#paint125_linear_2550_59381)"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.604 274.277L111.138 273.707L114.786 287.387V299.813H94.038V282.257L107.604 274.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.522 282.142L125.15 278.152L130.062 286.018V299.812H119.333V287.781L117.522 282.142Z",
    fill: "#33B6FF"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 269.744)",
    fill: "#0F8BFB"
  }))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.202 265.393H117.105L117.213 265.534L118.932 267.801L116.739 269.349L113.88 265.621L114.202 265.393Z",
    fill: "#F5F5F5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.105 265.393H114.202L113.88 265.621L104.738 272.102H107.908L117.213 265.534L117.105 265.393Z",
    fill: "#F5F5F5"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.412 273.631H113.509L113.402 273.49L111.682 271.222L113.875 269.674L116.734 273.402L116.412 273.631Z",
    fill: "#F5F5F5"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.509 273.631H116.412L116.734 273.402L125.876 266.921H122.706L113.402 273.49L113.509 273.631Z",
    fill: "#F5F5F5"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 269.326)",
    stroke: "url(#paint126_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 269.326)",
    stroke: "url(#paint127_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M122.429 269.261L123.186 268.955V269.411L122.637 269.627L122.429 269.261Z",
    fill: "#0B68BC"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M133.954 270.544L134.707 270.236V270.692L134.158 270.916L133.954 270.544Z",
    fill: "#0B68BC"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9435 270.233L99.1302 270.016V270.47L99.7581 270.639L99.9435 270.233Z",
    fill: "#0B68BC"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M111.01 272.134L110.652 271.295V271.75L110.857 272.217L111.01 272.134Z",
    fill: "#0B68BC"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1593 259.996C82.1593 265.316 85.5416 270.635 92.3062 274.694C105.835 282.812 127.771 282.812 141.3 274.694C148.064 270.635 151.447 265.316 151.447 259.996V251.026C151.447 245.707 148.064 240.387 141.3 236.328C127.771 228.211 105.835 228.211 92.3062 236.328C85.5416 240.387 82.1593 245.707 82.1593 251.026V259.996Z",
    fill: "url(#paint128_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 230,
    width: 70,
    height: 51
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1593 259.996C82.1593 265.316 85.5416 270.635 92.3062 274.694C105.835 282.812 127.771 282.812 141.3 274.694C148.064 270.635 151.447 265.316 151.447 259.996V251.026C151.447 245.707 148.064 240.387 141.3 236.328C127.771 228.211 105.835 228.211 92.3062 236.328C85.5416 240.387 82.1593 245.707 82.1593 251.026V259.996Z",
    fill: "url(#paint129_linear_2550_59381)"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.604 255.277L111.138 254.707L114.786 268.387V280.813H94.038V263.257L107.604 255.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter105_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.522 263.142L125.15 259.152L130.062 267.018V280.812H119.333V268.781L117.522 263.142Z",
    fill: "#33B6FF"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter106_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 250.744)",
    fill: "#0F8BFB"
  }))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.202 246.393H117.105L117.213 246.534L118.932 248.801L116.739 250.349L113.88 246.621L114.202 246.393Z",
    fill: "#F5F5F5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.105 246.393H114.202L113.88 246.621L104.738 253.102H107.908L117.213 246.534L117.105 246.393Z",
    fill: "#F5F5F5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.412 254.631H113.509L113.402 254.49L111.682 252.222L113.875 250.674L116.734 254.402L116.412 254.631Z",
    fill: "#F5F5F5"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.509 254.631H116.412L116.734 254.402L125.876 247.921H122.706L113.402 254.49L113.509 254.631Z",
    fill: "#F5F5F5"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 250.326)",
    stroke: "url(#paint130_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 250.326)",
    stroke: "url(#paint131_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M122.429 250.261L123.186 249.955V250.411L122.637 250.627L122.429 250.261Z",
    fill: "#0B68BC"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M133.954 251.544L134.707 251.236V251.692L134.158 251.916L133.954 251.544Z",
    fill: "#0B68BC"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9435 251.233L99.1302 251.016V251.47L99.7581 251.639L99.9435 251.233Z",
    fill: "#0B68BC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M111.01 253.134L110.652 252.295V252.75L110.857 253.217L111.01 253.134Z",
    fill: "#0B68BC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1593 243.996C82.1593 249.316 85.5416 254.635 92.3062 258.694C105.835 266.812 127.771 266.812 141.3 258.694C148.064 254.635 151.447 249.316 151.447 243.996V235.026C151.447 229.707 148.064 224.387 141.3 220.328C127.771 212.211 105.835 212.211 92.3062 220.328C85.5416 224.387 82.1593 229.707 82.1593 235.026V243.996Z",
    fill: "url(#paint132_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 214,
    width: 70,
    height: 51
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1593 243.996C82.1593 249.316 85.5416 254.635 92.3062 258.694C105.835 266.812 127.771 266.812 141.3 258.694C148.064 254.635 151.447 249.316 151.447 243.996V235.026C151.447 229.707 148.064 224.387 141.3 220.328C127.771 212.211 105.835 212.211 92.3062 220.328C85.5416 224.387 82.1593 229.707 82.1593 235.026V243.996Z",
    fill: "url(#paint133_linear_2550_59381)"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter107_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.604 239.277L111.138 238.707L114.786 252.387V264.813H94.038V247.257L107.604 239.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter108_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.522 247.142L125.15 243.152L130.062 251.018V264.812H119.333V252.781L117.522 247.142Z",
    fill: "#33B6FF"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter109_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 234.744)",
    fill: "#0F8BFB"
  }))), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.202 230.393H117.105L117.213 230.534L118.932 232.801L116.739 234.349L113.88 230.621L114.202 230.393Z",
    fill: "#F5F5F5"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.105 230.393H114.202L113.88 230.621L104.738 237.102H107.908L117.213 230.534L117.105 230.393Z",
    fill: "#F5F5F5"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.412 238.631H113.509L113.402 238.49L111.682 236.222L113.875 234.674L116.734 238.402L116.412 238.631Z",
    fill: "#F5F5F5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.509 238.631H116.412L116.734 238.402L125.876 231.921H122.706L113.402 238.49L113.509 238.631Z",
    fill: "#F5F5F5"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 234.326)",
    stroke: "url(#paint134_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 116.803 234.326)",
    stroke: "url(#paint135_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M122.429 234.261L123.186 233.955V234.411L122.637 234.627L122.429 234.261Z",
    fill: "#0B68BC"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M133.954 235.544L134.707 235.236V235.692L134.158 235.916L133.954 235.544Z",
    fill: "#0B68BC"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9435 235.233L99.1302 235.016V235.47L99.7581 235.639L99.9435 235.233Z",
    fill: "#0B68BC"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M111.01 237.134L110.652 236.295V236.75L110.857 237.217L111.01 237.134Z",
    fill: "#0B68BC"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1594 226.996C89.1594 232.316 92.5416 237.635 99.3062 241.694C112.835 249.812 134.771 249.812 148.3 241.694C155.064 237.635 158.447 232.316 158.447 226.996V218.026C158.447 212.707 155.064 207.387 148.3 203.328C134.771 195.211 112.835 195.211 99.3062 203.328C92.5416 207.387 89.1594 212.707 89.1594 218.026V226.996Z",
    fill: "url(#paint136_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 197,
    width: 70,
    height: 51
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1594 226.996C89.1594 232.316 92.5416 237.635 99.3062 241.694C112.835 249.812 134.771 249.812 148.3 241.694C155.064 237.635 158.447 232.316 158.447 226.996V218.026C158.447 212.707 155.064 207.387 148.3 203.328C134.771 195.211 112.835 195.211 99.3062 203.328C92.5416 207.387 89.1594 212.707 89.1594 218.026V226.996Z",
    fill: "url(#paint137_linear_2550_59381)"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter110_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.604 222.277L118.138 221.707L121.786 235.387V247.813H101.038V230.257L114.604 222.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter111_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.522 230.142L132.15 226.152L137.062 234.018V247.812H126.333V235.781L124.522 230.142Z",
    fill: "#33B6FF"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter112_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 123.803 217.744)",
    fill: "#0F8BFB"
  }))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.173 213.817L122.978 213.066L123.118 213.174L125.366 214.919L123.648 216.983L119.921 214.121L120.173 213.817Z",
    fill: "#F5F5F5"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.978 213.066L120.173 213.817L119.921 214.121L112.768 222.748L115.831 221.927L123.118 213.174L122.978 213.066Z",
    fill: "#F5F5F5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.44 221.202L121.636 221.954L121.496 221.845L119.248 220.1L120.966 218.037L124.693 220.898L124.44 221.202Z",
    fill: "#F5F5F5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.636 221.954L124.44 221.202L124.693 220.898L131.845 212.272L128.783 213.093L121.496 221.845L121.636 221.954Z",
    fill: "#F5F5F5"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 123.803 217.326)",
    stroke: "url(#paint138_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 123.803 217.326)",
    stroke: "url(#paint139_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8756 305.535C34.1271 309.745 40.0555 311.889 47.8902 310.966C63.5596 309.122 80.9205 295.715 86.6669 281.021C89.5401 273.674 88.9656 267.396 85.7141 263.186L80.2317 256.087C76.9802 251.876 71.0518 249.733 63.2171 250.655C47.5477 252.5 30.1868 265.907 24.4405 280.601C21.5673 287.948 22.1418 294.226 25.3932 298.436L30.8756 305.535Z",
    fill: "url(#paint140_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 250,
    width: 67,
    height: 62
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8756 305.535C34.1271 309.745 40.0555 311.889 47.8902 310.966C63.5596 309.122 80.9205 295.715 86.6669 281.021C89.5401 273.674 88.9656 267.396 85.7141 263.186L80.2317 256.087C76.9802 251.876 71.0518 249.733 63.2171 250.655C47.5477 252.5 30.1868 265.907 24.4405 280.601C21.5673 287.948 22.1418 294.226 25.3932 298.436L30.8756 305.535Z",
    fill: "url(#paint141_linear_2550_59381)"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter113_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1298 286.247L50.5784 283.636L61.8271 292.234L69.422 302.068L53.0007 314.75L42.2703 300.855L48.1298 286.247Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter114_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7872 286.412L64.3862 278.591L73.0813 281.815L81.5124 292.732L73.021 299.29L65.6673 289.768L60.7872 286.412Z",
    fill: "#33B6FF"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter115_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.379851 -0.925048 0.991032 -0.133626 52.64 277.037)",
    fill: "#0F8BFB"
  }))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9215 275.183L50.2195 273.408L50.3906 273.454L53.1374 274.198L52.3478 276.764L47.8061 275.56L47.9215 275.183Z",
    fill: "#F5F5F5"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2195 273.408L47.9215 275.183L47.8061 275.56L44.5319 286.277L47.0411 284.34L50.3906 273.454L50.2195 273.408Z",
    fill: "#F5F5F5"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.706 280.353L52.408 282.127L52.2369 282.081L49.4901 281.338L50.2797 278.771L54.8214 279.975L54.706 280.353Z",
    fill: "#F5F5F5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.408 282.127L54.706 280.353L54.8214 279.975L58.0956 269.258L55.5864 271.195L52.2369 282.081L52.408 282.127Z",
    fill: "#F5F5F5"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.379851 -0.925048 0.991032 -0.133626 52.3842 276.707)",
    stroke: "url(#paint142_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.379851 -0.925048 0.991032 -0.133626 52.3843 276.706)",
    stroke: "url(#paint143_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M129.429 217.261L130.186 216.955V217.411L129.637 217.627L129.429 217.261Z",
    fill: "#0B68BC"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M106.944 218.233L106.13 218.016V218.47L106.758 218.639L106.944 218.233Z",
    fill: "#0B68BC"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M118.01 220.134L117.652 219.295V219.75L117.857 220.217L118.01 220.134Z",
    fill: "#0B68BC"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0503 269.151C70.7192 269.709 70.6286 268.9 69.9253 272.862C69.8926 273.046 69.5142 273.046 69.4808 272.862C68.7775 268.9 68.6832 269.709 66.3565 269.151C66.152 269.102 66.152 268.899 66.3565 268.85C68.6868 268.291 68.7775 269.1 69.4808 265.139C69.5142 264.954 69.8926 264.954 69.9253 265.139C70.6286 269.1 70.7228 268.291 73.0503 268.85C73.2541 268.899 73.2541 269.102 73.0503 269.151Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter116_f_2550_59381)"
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M234.203 271C252.429 271 267.203 276.82 267.203 284C267.203 291.18 252.429 297 234.203 297C215.978 297 201.203 291.18 201.203 284C201.203 276.82 215.978 271 234.203 271Z",
    fill: "#CCCCCC"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.16 272.996C205.16 278.316 208.542 283.635 215.306 287.694C228.836 295.812 250.771 295.812 264.3 287.694C271.065 283.635 274.447 278.316 274.447 272.996V264.026C274.447 258.707 271.065 253.387 264.3 249.328C250.771 241.211 228.836 241.211 215.306 249.328C208.542 253.387 205.16 258.707 205.16 264.026V272.996Z",
    fill: "url(#paint144_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 243,
    width: 70,
    height: 51
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.16 272.996C205.16 278.316 208.542 283.635 215.306 287.694C228.836 295.812 250.771 295.812 264.3 287.694C271.065 283.635 274.447 278.316 274.447 272.996V264.026C274.447 258.707 271.065 253.387 264.3 249.328C250.771 241.211 228.836 241.211 215.306 249.328C208.542 253.387 205.16 258.707 205.16 264.026V272.996Z",
    fill: "url(#paint145_linear_2550_59381)"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter117_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.604 268.277L234.138 267.707L237.786 281.387V293.813H217.038V276.257L230.604 268.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter118_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.522 276.142L248.151 272.152L253.062 280.018V293.812H242.333V281.781L240.522 276.142Z",
    fill: "#33B6FF"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter119_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 239.803 263.744)",
    fill: "#0F8BFB"
  }))), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.202 259.393H240.106L240.213 259.534L241.932 261.801L239.739 263.349L236.88 259.621L237.202 259.393Z",
    fill: "#F5F5F5"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.106 259.393H237.202L236.88 259.621L227.738 266.102H230.908L240.213 259.534L240.106 259.393Z",
    fill: "#F5F5F5"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.412 267.631H236.509L236.402 267.49L234.682 265.222L236.875 263.674L239.734 267.402L239.412 267.631Z",
    fill: "#F5F5F5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.509 267.631H239.412L239.734 267.402L248.876 260.921H245.706L236.402 267.49L236.509 267.631Z",
    fill: "#F5F5F5"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 239.803 263.326)",
    stroke: "url(#paint146_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 239.803 263.326)",
    stroke: "url(#paint147_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M245.429 263.261L246.186 262.955V263.411L245.637 263.627L245.429 263.261Z",
    fill: "#0B68BC"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M256.954 264.544L257.707 264.236V264.692L257.158 264.916L256.954 264.544Z",
    fill: "#0B68BC"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M222.944 264.233L222.13 264.016V264.47L222.758 264.639L222.944 264.233Z",
    fill: "#0B68BC"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M234.011 266.134L233.652 265.295V265.75L233.858 266.217L234.011 266.134Z",
    fill: "#0B68BC"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.16 256.996C206.16 262.316 209.542 267.635 216.306 271.694C229.836 279.812 251.771 279.812 265.3 271.694C272.065 267.635 275.447 262.316 275.447 256.996V248.026C275.447 242.707 272.065 237.387 265.3 233.328C251.771 225.211 229.836 225.211 216.306 233.328C209.542 237.387 206.16 242.707 206.16 248.026V256.996Z",
    fill: "url(#paint148_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 227,
    width: 70,
    height: 51
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.16 256.996C206.16 262.316 209.542 267.635 216.306 271.694C229.836 279.812 251.771 279.812 265.3 271.694C272.065 267.635 275.447 262.316 275.447 256.996V248.026C275.447 242.707 272.065 237.387 265.3 233.328C251.771 225.211 229.836 225.211 216.306 233.328C209.542 237.387 206.16 242.707 206.16 248.026V256.996Z",
    fill: "url(#paint149_linear_2550_59381)"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter120_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.604 252.277L235.138 251.707L238.786 265.387V277.813H218.038V260.257L231.604 252.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter121_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.522 260.142L249.151 256.152L254.062 264.018V277.812H243.333V265.781L241.522 260.142Z",
    fill: "#33B6FF"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter122_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 247.744)",
    fill: "#0F8BFB"
  }))), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.202 243.393H241.106L241.213 243.534L242.932 245.801L240.739 247.349L237.88 243.621L238.202 243.393Z",
    fill: "#F5F5F5"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.106 243.393H238.202L237.88 243.621L228.738 250.102H231.908L241.213 243.534L241.106 243.393Z",
    fill: "#F5F5F5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.412 251.631H237.509L237.402 251.49L235.682 249.222L237.875 247.674L240.734 251.402L240.412 251.631Z",
    fill: "#F5F5F5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.509 251.631H240.412L240.734 251.402L249.876 244.921H246.706L237.402 251.49L237.509 251.631Z",
    fill: "#F5F5F5"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 247.326)",
    stroke: "url(#paint150_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 247.326)",
    stroke: "url(#paint151_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M246.429 247.261L247.186 246.955V247.411L246.637 247.627L246.429 247.261Z",
    fill: "#0B68BC"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M257.954 248.544L258.707 248.236V248.692L258.158 248.916L257.954 248.544Z",
    fill: "#0B68BC"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M223.944 248.233L223.13 248.016V248.47L223.758 248.639L223.944 248.233Z",
    fill: "#0B68BC"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M235.011 250.134L234.652 249.295V249.75L234.858 250.217L235.011 250.134Z",
    fill: "#0B68BC"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.16 237.996C206.16 243.316 209.542 248.635 216.306 252.694C229.836 260.812 251.771 260.812 265.3 252.694C272.065 248.635 275.447 243.316 275.447 237.996V229.026C275.447 223.707 272.065 218.387 265.3 214.328C251.771 206.211 229.836 206.211 216.306 214.328C209.542 218.387 206.16 223.707 206.16 229.026V237.996Z",
    fill: "url(#paint152_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 208,
    width: 70,
    height: 51
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.16 237.996C206.16 243.316 209.542 248.635 216.306 252.694C229.836 260.812 251.771 260.812 265.3 252.694C272.065 248.635 275.447 243.316 275.447 237.996V229.026C275.447 223.707 272.065 218.387 265.3 214.328C251.771 206.211 229.836 206.211 216.306 214.328C209.542 218.387 206.16 223.707 206.16 229.026V237.996Z",
    fill: "url(#paint153_linear_2550_59381)"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter123_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.604 233.277L235.138 232.707L238.786 246.387V258.813H218.038V241.257L231.604 233.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter124_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.522 241.142L249.151 237.152L254.062 245.018V258.812H243.333V246.781L241.522 241.142Z",
    fill: "#33B6FF"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter125_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 228.744)",
    fill: "#0F8BFB"
  }))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.202 224.393H241.106L241.213 224.534L242.932 226.801L240.739 228.349L237.88 224.621L238.202 224.393Z",
    fill: "#F5F5F5"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.106 224.393H238.202L237.88 224.621L228.738 231.102H231.908L241.213 224.534L241.106 224.393Z",
    fill: "#F5F5F5"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.412 232.631H237.509L237.402 232.49L235.682 230.222L237.875 228.674L240.734 232.402L240.412 232.631Z",
    fill: "#F5F5F5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.509 232.631H240.412L240.734 232.402L249.876 225.921H246.706L237.402 232.49L237.509 232.631Z",
    fill: "#F5F5F5"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 228.326)",
    stroke: "url(#paint154_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 228.326)",
    stroke: "url(#paint155_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M246.429 228.261L247.186 227.955V228.411L246.637 228.627L246.429 228.261Z",
    fill: "#0B68BC"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M257.954 229.544L258.707 229.236V229.692L258.158 229.916L257.954 229.544Z",
    fill: "#0B68BC"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M223.944 229.233L223.13 229.016V229.47L223.758 229.639L223.944 229.233Z",
    fill: "#0B68BC"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M235.011 231.134L234.652 230.295V230.75L234.858 231.217L235.011 231.134Z",
    fill: "#0B68BC"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.16 221.996C206.16 227.316 209.542 232.635 216.306 236.694C229.836 244.812 251.771 244.812 265.3 236.694C272.065 232.635 275.447 227.316 275.447 221.996V213.026C275.447 207.707 272.065 202.387 265.3 198.328C251.771 190.211 229.836 190.211 216.306 198.328C209.542 202.387 206.16 207.707 206.16 213.026V221.996Z",
    fill: "url(#paint156_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 192,
    width: 70,
    height: 51
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.16 221.996C206.16 227.316 209.542 232.635 216.306 236.694C229.836 244.812 251.771 244.812 265.3 236.694C272.065 232.635 275.447 227.316 275.447 221.996V213.026C275.447 207.707 272.065 202.387 265.3 198.328C251.771 190.211 229.836 190.211 216.306 198.328C209.542 202.387 206.16 207.707 206.16 213.026V221.996Z",
    fill: "url(#paint157_linear_2550_59381)"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter126_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.604 217.277L235.138 216.707L238.786 230.387V242.813H218.038V225.257L231.604 217.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter127_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.522 225.142L249.151 221.152L254.062 229.018V242.812H243.333V230.781L241.522 225.142Z",
    fill: "#33B6FF"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter128_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 212.744)",
    fill: "#0F8BFB"
  }))), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.202 208.393H241.106L241.213 208.534L242.932 210.801L240.739 212.349L237.88 208.621L238.202 208.393Z",
    fill: "#F5F5F5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.106 208.393H238.202L237.88 208.621L228.738 215.102H231.908L241.213 208.534L241.106 208.393Z",
    fill: "#F5F5F5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.412 216.631H237.509L237.402 216.49L235.682 214.222L237.875 212.674L240.734 216.402L240.412 216.631Z",
    fill: "#F5F5F5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.509 216.631H240.412L240.734 216.402L249.876 209.921H246.706L237.402 216.49L237.509 216.631Z",
    fill: "#F5F5F5"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 212.326)",
    stroke: "url(#paint158_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 240.803 212.326)",
    stroke: "url(#paint159_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M246.429 212.261L247.186 211.955V212.411L246.637 212.627L246.429 212.261Z",
    fill: "#0B68BC"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M257.954 213.544L258.707 213.236V213.692L258.158 213.916L257.954 213.544Z",
    fill: "#0B68BC"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M223.944 213.233L223.13 213.016V213.47L223.758 213.639L223.944 213.233Z",
    fill: "#0B68BC"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M235.011 215.134L234.652 214.295V214.75L234.858 215.217L235.011 215.134Z",
    fill: "#0B68BC"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.16 205.996C207.16 211.316 210.542 216.635 217.306 220.694C230.836 228.812 252.771 228.812 266.3 220.694C273.065 216.635 276.447 211.316 276.447 205.996V197.026C276.447 191.707 273.065 186.387 266.3 182.328C252.771 174.211 230.836 174.211 217.306 182.328C210.542 186.387 207.16 191.707 207.16 197.026V205.996Z",
    fill: "url(#paint160_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 176,
    width: 70,
    height: 51
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.16 205.996C207.16 211.316 210.542 216.635 217.306 220.694C230.836 228.812 252.771 228.812 266.3 220.694C273.065 216.635 276.447 211.316 276.447 205.996V197.026C276.447 191.707 273.065 186.387 266.3 182.328C252.771 174.211 230.836 174.211 217.306 182.328C210.542 186.387 207.16 191.707 207.16 197.026V205.996Z",
    fill: "url(#paint161_linear_2550_59381)"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter129_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.604 201.277L236.138 200.707L239.786 214.387V226.813H219.038V209.257L232.604 201.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter130_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.522 209.142L250.151 205.152L255.062 213.018V226.812H244.333V214.781L242.522 209.142Z",
    fill: "#33B6FF"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter131_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 196.744)",
    fill: "#0F8BFB"
  }))), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.202 192.393H242.106L242.213 192.534L243.932 194.801L241.739 196.349L238.88 192.621L239.202 192.393Z",
    fill: "#F5F5F5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.106 192.393H239.202L238.88 192.621L229.738 199.102H232.908L242.213 192.534L242.106 192.393Z",
    fill: "#F5F5F5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.412 200.631H238.509L238.402 200.49L236.682 198.222L238.875 196.674L241.734 200.402L241.412 200.631Z",
    fill: "#F5F5F5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.509 200.631H241.412L241.734 200.402L250.876 193.921H247.706L238.402 200.49L238.509 200.631Z",
    fill: "#F5F5F5"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 196.326)",
    stroke: "url(#paint162_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 196.326)",
    stroke: "url(#paint163_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.16 188.996C207.16 194.316 210.542 199.635 217.306 203.694C230.836 211.812 252.771 211.812 266.3 203.694C273.065 199.635 276.447 194.316 276.447 188.996V180.026C276.447 174.707 273.065 169.387 266.3 165.328C252.771 157.211 230.836 157.211 217.306 165.328C210.542 169.387 207.16 174.707 207.16 180.026V188.996Z",
    fill: "url(#paint164_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 159,
    width: 70,
    height: 51
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.16 188.996C207.16 194.316 210.542 199.635 217.306 203.694C230.836 211.812 252.771 211.812 266.3 203.694C273.065 199.635 276.447 194.316 276.447 188.996V180.026C276.447 174.707 273.065 169.387 266.3 165.328C252.771 157.211 230.836 157.211 217.306 165.328C210.542 169.387 207.16 174.707 207.16 180.026V188.996Z",
    fill: "url(#paint165_linear_2550_59381)"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter132_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.604 184.277L236.138 183.707L239.786 197.387V209.813H219.038V192.257L232.604 184.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter133_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.522 192.142L250.151 188.152L255.062 196.018V209.812H244.333V197.781L242.522 192.142Z",
    fill: "#33B6FF"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter134_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 179.744)",
    fill: "#0F8BFB"
  }))), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.202 175.393H242.106L242.213 175.534L243.932 177.801L241.739 179.349L238.88 175.621L239.202 175.393Z",
    fill: "#F5F5F5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.106 175.393H239.202L238.88 175.621L229.738 182.102H232.908L242.213 175.534L242.106 175.393Z",
    fill: "#F5F5F5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.412 183.631H238.509L238.402 183.49L236.682 181.222L238.875 179.674L241.734 183.402L241.412 183.631Z",
    fill: "#F5F5F5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.509 183.631H241.412L241.734 183.402L250.876 176.921H247.706L238.402 183.49L238.509 183.631Z",
    fill: "#F5F5F5"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 179.326)",
    stroke: "url(#paint166_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 179.326)",
    stroke: "url(#paint167_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.16 169.996C207.16 175.316 210.542 180.635 217.306 184.694C230.836 192.812 252.771 192.812 266.3 184.694C273.065 180.635 276.447 175.316 276.447 169.996V161.026C276.447 155.707 273.065 150.387 266.3 146.328C252.771 138.211 230.836 138.211 217.306 146.328C210.542 150.387 207.16 155.707 207.16 161.026V169.996Z",
    fill: "url(#paint168_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 140,
    width: 70,
    height: 51
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.16 169.996C207.16 175.316 210.542 180.635 217.306 184.694C230.836 192.812 252.771 192.812 266.3 184.694C273.065 180.635 276.447 175.316 276.447 169.996V161.026C276.447 155.707 273.065 150.387 266.3 146.328C252.771 138.211 230.836 138.211 217.306 146.328C210.542 150.387 207.16 155.707 207.16 161.026V169.996Z",
    fill: "url(#paint169_linear_2550_59381)"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter135_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.604 165.277L236.138 164.707L239.786 178.387V190.813H219.038V173.257L232.604 165.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter136_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.522 173.142L250.151 169.152L255.062 177.018V190.812H244.333V178.781L242.522 173.142Z",
    fill: "#33B6FF"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter137_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 160.744)",
    fill: "#0F8BFB"
  }))), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.202 156.393H242.106L242.213 156.534L243.932 158.801L241.739 160.349L238.88 156.621L239.202 156.393Z",
    fill: "#F5F5F5"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.106 156.393H239.202L238.88 156.621L229.738 163.102H232.908L242.213 156.534L242.106 156.393Z",
    fill: "#F5F5F5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.412 164.631H238.509L238.402 164.49L236.682 162.222L238.875 160.674L241.734 164.402L241.412 164.631Z",
    fill: "#F5F5F5"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.509 164.631H241.412L241.734 164.402L250.876 157.921H247.706L238.402 164.49L238.509 164.631Z",
    fill: "#F5F5F5"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 160.326)",
    stroke: "url(#paint170_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 241.803 160.326)",
    stroke: "url(#paint171_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.16 153.996C212.16 159.316 215.542 164.635 222.306 168.694C235.836 176.812 257.771 176.812 271.3 168.694C278.065 164.635 281.447 159.316 281.447 153.996V145.026C281.447 139.707 278.065 134.387 271.3 130.328C257.771 122.211 235.836 122.211 222.306 130.328C215.542 134.387 212.16 139.707 212.16 145.026V153.996Z",
    fill: "url(#paint172_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 124,
    width: 70,
    height: 51
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.16 153.996C212.16 159.316 215.542 164.635 222.306 168.694C235.836 176.812 257.771 176.812 271.3 168.694C278.065 164.635 281.447 159.316 281.447 153.996V145.026C281.447 139.707 278.065 134.387 271.3 130.328C257.771 122.211 235.836 122.211 222.306 130.328C215.542 134.387 212.16 139.707 212.16 145.026V153.996Z",
    fill: "url(#paint173_linear_2550_59381)"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter138_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.604 149.277L241.138 148.707L244.786 162.387V174.813H224.038V157.257L237.604 149.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter139_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.522 157.142L255.151 153.152L260.062 161.018V174.812H249.333V162.781L247.522 157.142Z",
    fill: "#33B6FF"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter140_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 246.803 144.744)",
    fill: "#0F8BFB"
  }))), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.202 140.393H247.106L247.213 140.534L248.932 142.801L246.739 144.349L243.88 140.621L244.202 140.393Z",
    fill: "#F5F5F5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.106 140.393H244.202L243.88 140.621L234.738 147.102H237.908L247.213 140.534L247.106 140.393Z",
    fill: "#F5F5F5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.412 148.631H243.509L243.402 148.49L241.682 146.222L243.875 144.674L246.734 148.402L246.412 148.631Z",
    fill: "#F5F5F5"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.509 148.631H246.412L246.734 148.402L255.876 141.921H252.706L243.402 148.49L243.509 148.631Z",
    fill: "#F5F5F5"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 246.803 144.326)",
    stroke: "url(#paint174_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 246.803 144.326)",
    stroke: "url(#paint175_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.16 138.996C200.16 144.316 203.542 149.635 210.306 153.694C223.836 161.812 245.771 161.812 259.3 153.694C266.065 149.635 269.447 144.316 269.447 138.996V130.026C269.447 124.707 266.065 119.387 259.3 115.328C245.771 107.211 223.836 107.211 210.306 115.328C203.542 119.387 200.16 124.707 200.16 130.026V138.996Z",
    fill: "url(#paint176_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 109,
    width: 70,
    height: 51
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.16 138.996C200.16 144.316 203.542 149.635 210.306 153.694C223.836 161.812 245.771 161.812 259.3 153.694C266.065 149.635 269.447 144.316 269.447 138.996V130.026C269.447 124.707 266.065 119.387 259.3 115.328C245.771 107.211 223.836 107.211 210.306 115.328C203.542 119.387 200.16 124.707 200.16 130.026V138.996Z",
    fill: "url(#paint177_linear_2550_59381)"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter141_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.604 134.277L229.138 133.707L232.786 147.387V159.813H212.038V142.257L225.604 134.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter142_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.522 142.142L243.151 138.152L248.062 146.018V159.812H237.333V147.781L235.522 142.142Z",
    fill: "#33B6FF"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter143_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 234.803 129.744)",
    fill: "#0F8BFB"
  }))), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.41 125.391L236.924 126.843L236.946 127.019L237.302 129.842L234.628 130.086L234.016 125.428L234.41 125.391Z",
    fill: "#F5F5F5"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.924 126.843L234.41 125.391L234.016 125.428L222.859 126.47L225.604 128.055L236.946 127.019L236.924 126.843Z",
    fill: "#F5F5F5"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.205 133.63L229.69 132.179L229.668 132.003L229.312 129.179L231.986 128.935L232.598 133.594L232.205 133.63Z",
    fill: "#F5F5F5"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.69 132.179L232.205 133.63L232.598 133.594L243.755 132.552L241.01 130.967L229.668 132.003L229.69 132.179Z",
    fill: "#F5F5F5"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 234.803 129.326)",
    stroke: "url(#paint178_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 234.803 129.326)",
    stroke: "url(#paint179_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M253.429 195.261L254.186 194.955V195.411L253.637 195.627L253.429 195.261Z",
    fill: "#0B68BC"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M230.944 196.233L230.13 196.016V196.47L230.758 196.639L230.944 196.233Z",
    fill: "#0B68BC"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M242.011 198.134L241.652 197.295V197.75L241.858 198.217L242.011 198.134Z",
    fill: "#0B68BC"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M241.05 248.151C238.719 248.709 238.629 247.9 237.925 251.862C237.893 252.046 237.514 252.046 237.481 251.862C236.777 247.9 236.683 248.709 234.356 248.151C234.152 248.102 234.152 247.899 234.356 247.85C236.687 247.291 236.777 248.1 237.481 244.139C237.514 243.954 237.893 243.954 237.925 244.139C238.629 248.1 238.723 247.291 241.05 247.85C241.254 247.899 241.254 248.102 241.05 248.151Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M262.05 181.151C259.719 181.709 259.629 180.9 258.925 184.862C258.893 185.046 258.514 185.046 258.481 184.862C257.777 180.9 257.683 181.709 255.356 181.151C255.152 181.102 255.152 180.899 255.356 180.85C257.687 180.291 257.777 181.1 258.481 177.139C258.514 176.954 258.893 176.954 258.925 177.139C259.629 181.1 259.723 180.291 262.05 180.85C262.254 180.899 262.254 181.102 262.05 181.151Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M314.05 219.151C311.719 219.709 311.629 218.9 310.925 222.862C310.893 223.046 310.514 223.046 310.481 222.862C309.777 218.9 309.683 219.709 307.356 219.151C307.152 219.102 307.152 218.899 307.356 218.85C309.687 218.291 309.777 219.1 310.481 215.139C310.514 214.954 310.893 214.954 310.925 215.139C311.629 219.1 311.723 218.291 314.05 218.85C314.254 218.899 314.254 219.102 314.05 219.151Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.16 290.996C152.16 296.316 155.542 301.635 162.306 305.694C175.836 313.812 197.771 313.812 211.3 305.694C218.065 301.635 221.447 296.316 221.447 290.996V282.026C221.447 276.707 218.065 271.387 211.3 267.328C197.771 259.211 175.836 259.211 162.306 267.328C155.542 271.387 152.16 276.707 152.16 282.026V290.996Z",
    fill: "url(#paint180_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 261,
    width: 70,
    height: 51
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.16 290.996C152.16 296.316 155.542 301.635 162.306 305.694C175.836 313.812 197.771 313.812 211.3 305.694C218.065 301.635 221.447 296.316 221.447 290.996V282.026C221.447 276.707 218.065 271.387 211.3 267.328C197.771 259.211 175.836 259.211 162.306 267.328C155.542 271.387 152.16 276.707 152.16 282.026V290.996Z",
    fill: "url(#paint181_linear_2550_59381)"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter144_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.604 286.277L181.138 285.707L184.786 299.387V311.813H164.038V294.257L177.604 286.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter145_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.522 294.142L195.151 290.152L200.062 298.018V311.812H189.333V299.781L187.522 294.142Z",
    fill: "#33B6FF"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter146_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 186.803 281.744)",
    fill: "#0F8BFB"
  }))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.202 277.393H187.106L187.213 277.534L188.932 279.801L186.739 281.349L183.88 277.621L184.202 277.393Z",
    fill: "#F5F5F5"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.106 277.393H184.202L183.88 277.621L174.738 284.102H177.908L187.213 277.534L187.106 277.393Z",
    fill: "#F5F5F5"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.412 285.631H183.509L183.402 285.49L181.682 283.222L183.875 281.674L186.734 285.402L186.412 285.631Z",
    fill: "#F5F5F5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.509 285.631H186.412L186.734 285.402L195.876 278.921H192.706L183.402 285.49L183.509 285.631Z",
    fill: "#F5F5F5"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 186.803 281.326)",
    stroke: "url(#paint182_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 186.803 281.326)",
    stroke: "url(#paint183_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M192.43 281.261L193.186 280.955V281.411L192.637 281.627L192.43 281.261Z",
    fill: "#0B68BC"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 282.544L204.707 282.236V282.692L204.158 282.916L203.954 282.544Z",
    fill: "#0B68BC"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M169.944 282.233L169.13 282.016V282.47L169.758 282.639L169.944 282.233Z",
    fill: "#0B68BC"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M181.011 284.134L180.652 283.295V283.75L180.858 284.217L181.011 284.134Z",
    fill: "#0B68BC"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.16 269.996C158.16 275.316 161.542 280.635 168.306 284.694C181.836 292.812 203.771 292.812 217.3 284.694C224.065 280.635 227.447 275.316 227.447 269.996V261.026C227.447 255.707 224.065 250.387 217.3 246.328C203.771 238.211 181.836 238.211 168.306 246.328C161.542 250.387 158.16 255.707 158.16 261.026V269.996Z",
    fill: "url(#paint184_linear_2550_59381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2550_59381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 240,
    width: 70,
    height: 51
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.16 269.996C158.16 275.316 161.542 280.635 168.306 284.694C181.836 292.812 203.771 292.812 217.3 284.694C224.065 280.635 227.447 275.316 227.447 269.996V261.026C227.447 255.707 224.065 250.387 217.3 246.328C203.771 238.211 181.836 238.211 168.306 246.328C161.542 250.387 158.16 255.707 158.16 261.026V269.996Z",
    fill: "url(#paint185_linear_2550_59381)"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2550_59381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter147_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.604 265.277L187.138 264.707L190.786 278.387V290.813H170.038V273.257L183.604 265.277Z",
    fill: "#2883F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter148_f_2550_59381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.522 273.142L201.151 269.152L206.062 277.018V290.812H195.333V278.781L193.522 273.142Z",
    fill: "#33B6FF"
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter149_i_2550_59381)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 18.4287,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 192.803 260.744)",
    fill: "#0F8BFB"
  }))), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.202 256.393H193.106L193.213 256.534L194.932 258.801L192.739 260.349L189.88 256.621L190.202 256.393Z",
    fill: "#F5F5F5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.106 256.393H190.202L189.88 256.621L180.738 263.102H183.908L193.213 256.534L193.106 256.393Z",
    fill: "#F5F5F5"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.412 264.631H189.509L189.402 264.49L187.682 262.222L189.875 260.674L192.734 264.402L192.412 264.631Z",
    fill: "#F5F5F5"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.509 264.631H192.412L192.734 264.402L201.876 257.921H198.706L189.402 264.49L189.509 264.631Z",
    fill: "#F5F5F5"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    r: 26.3267,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 192.803 260.326)",
    stroke: "url(#paint186_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    r: 18.3371,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 192.803 260.326)",
    stroke: "url(#paint187_linear_2550_59381)",
    strokeWidth: 2.43974
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M198.43 260.261L199.186 259.955V260.411L198.637 260.627L198.43 260.261Z",
    fill: "#0B68BC"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M209.954 261.544L210.707 261.236V261.692L210.158 261.916L209.954 261.544Z",
    fill: "#0B68BC"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M175.944 261.233L175.13 261.016V261.47L175.758 261.639L175.944 261.233Z",
    fill: "#0B68BC"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M187.011 263.134L186.652 262.295V262.75L186.858 263.217L187.011 263.134Z",
    fill: "#0B68BC"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M171.745 264.452C164.751 266.128 164.479 263.7 162.37 275.585C162.272 276.138 161.136 276.138 161.036 275.585C158.926 263.7 158.643 266.128 151.663 264.452C151.05 264.305 151.05 263.697 151.663 263.55C158.654 261.873 158.926 264.299 161.036 252.417C161.136 251.861 162.272 251.861 162.37 252.417C164.479 264.299 164.762 261.873 171.745 263.55C172.356 263.697 172.356 264.305 171.745 264.452Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2550_59381",
    x: 90.2031,
    y: 210,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2550_59381",
    x: 99.0381,
    y: 210.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2550_59381",
    x: 124.522,
    y: 217.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2550_59381",
    x: 103.232,
    y: 197.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2550_59381",
    x: 100.038,
    y: 194.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2550_59381",
    x: 125.522,
    y: 201.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_2550_59381",
    x: 104.232,
    y: 181.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2550_59381",
    x: 100.038,
    y: 175.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2550_59381",
    x: 125.522,
    y: 182.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_2550_59381",
    x: 104.232,
    y: 162.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2550_59381",
    x: 100.038,
    y: 159.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2550_59381",
    x: 125.522,
    y: 166.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_2550_59381",
    x: 104.232,
    y: 146.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2550_59381",
    x: 101.038,
    y: 143.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2550_59381",
    x: 126.522,
    y: 150.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_2550_59381",
    x: 105.232,
    y: 130.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_2550_59381",
    x: 101.038,
    y: 126.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2550_59381",
    x: 126.522,
    y: 133.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_2550_59381",
    x: 105.232,
    y: 113.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_2550_59381",
    x: 101.038,
    y: 107.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_2550_59381",
    x: 126.522,
    y: 114.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_2550_59381",
    x: 105.232,
    y: 94.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_2550_59381",
    x: 101.038,
    y: 90.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_2550_59381",
    x: 126.522,
    y: 97.1523,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_2550_59381",
    x: 105.232,
    y: 77.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_2550_59381",
    x: 89.0381,
    y: 79.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_2550_59381",
    x: 114.522,
    y: 86.1523,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_2550_59381",
    x: 93.2323,
    y: 66.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_2550_59381",
    x: 160.203,
    y: 162,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_2550_59381",
    x: 169.038,
    y: 162.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_2550_59381",
    x: 194.522,
    y: 169.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_2550_59381",
    x: 173.232,
    y: 149.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_2550_59381",
    x: 170.038,
    y: 146.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_2550_59381",
    x: 195.522,
    y: 153.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_i_2550_59381",
    x: 174.232,
    y: 133.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_2550_59381",
    x: 170.038,
    y: 127.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_2550_59381",
    x: 195.522,
    y: 134.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_i_2550_59381",
    x: 174.232,
    y: 114.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_2550_59381",
    x: 170.038,
    y: 111.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_2550_59381",
    x: 195.522,
    y: 118.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_i_2550_59381",
    x: 174.232,
    y: 98.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_f_2550_59381",
    x: 171.038,
    y: 95.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_2550_59381",
    x: 196.522,
    y: 102.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_i_2550_59381",
    x: 175.232,
    y: 82.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_2550_59381",
    x: 171.038,
    y: 78.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_2550_59381",
    x: 196.522,
    y: 85.1523,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_i_2550_59381",
    x: 175.232,
    y: 65.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_f_2550_59381",
    x: 171.038,
    y: 59.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_f_2550_59381",
    x: 196.522,
    y: 66.1523,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_i_2550_59381",
    x: 175.232,
    y: 46.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_2550_59381",
    x: 171.038,
    y: 42.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_2550_59381",
    x: 196.522,
    y: 49.1523,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_i_2550_59381",
    x: 175.232,
    y: 29.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_2550_59381",
    x: 180.038,
    y: 26.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_2550_59381",
    x: 205.522,
    y: 33.1523,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_i_2550_59381",
    x: 184.232,
    y: 13.7129,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_f_2550_59381",
    x: 145.203,
    y: 279,
    width: 84,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_2550_59381",
    x: 142.203,
    y: 252,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_2550_59381",
    x: 151.038,
    y: 252.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_2550_59381",
    x: 176.522,
    y: 259.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_i_2550_59381",
    x: 155.232,
    y: 239.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_2550_59381",
    x: 152.038,
    y: 236.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_2550_59381",
    x: 177.522,
    y: 243.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_i_2550_59381",
    x: 156.232,
    y: 223.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_2550_59381",
    x: 152.038,
    y: 217.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_2550_59381",
    x: 177.522,
    y: 224.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_i_2550_59381",
    x: 156.232,
    y: 204.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_2550_59381",
    x: 152.038,
    y: 201.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_f_2550_59381",
    x: 177.522,
    y: 208.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_i_2550_59381",
    x: 156.232,
    y: 188.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_f_2550_59381",
    x: 146.038,
    y: 187.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_f_2550_59381",
    x: 171.522,
    y: 194.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_i_2550_59381",
    x: 150.232,
    y: 174.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_f_2550_59381",
    x: 147.038,
    y: 168.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_f_2550_59381",
    x: 172.522,
    y: 175.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_i_2550_59381",
    x: 151.232,
    y: 155.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_f_2550_59381",
    x: 25.2031,
    y: 251,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_f_2550_59381",
    x: 34.0381,
    y: 251.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_f_2550_59381",
    x: 59.5221,
    y: 258.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter79_i_2550_59381",
    x: 38.2323,
    y: 238.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter80_f_2550_59381",
    x: 35.0381,
    y: 235.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter81_f_2550_59381",
    x: 60.5221,
    y: 242.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter82_i_2550_59381",
    x: 39.2323,
    y: 222.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter83_f_2550_59381",
    x: 35.0381,
    y: 216.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter84_f_2550_59381",
    x: 60.5221,
    y: 223.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter85_i_2550_59381",
    x: 39.2323,
    y: 203.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter86_f_2550_59381",
    x: 35.0381,
    y: 200.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter87_f_2550_59381",
    x: 60.5221,
    y: 207.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter88_i_2550_59381",
    x: 39.2323,
    y: 187.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter89_f_2550_59381",
    x: 38.0381,
    y: 186.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter90_f_2550_59381",
    x: 63.5221,
    y: 193.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter91_i_2550_59381",
    x: 42.2323,
    y: 173.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter92_f_2550_59381",
    x: 39.0381,
    y: 167.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter93_f_2550_59381",
    x: 64.5221,
    y: 174.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter94_i_2550_59381",
    x: 43.2323,
    y: 154.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter95_f_2550_59381",
    x: 80.2031,
    y: 285,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter96_f_2550_59381",
    x: 37.2031,
    y: 282,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter97_f_2550_59381",
    x: 70.2031,
    y: 257,
    width: 209,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter98_f_2550_59381",
    x: 89.038,
    y: 285.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter99_f_2550_59381",
    x: 114.522,
    y: 292.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter100_i_2550_59381",
    x: 93.2321,
    y: 272.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter101_f_2550_59381",
    x: 90.038,
    y: 269.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter102_f_2550_59381",
    x: 115.522,
    y: 276.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter103_i_2550_59381",
    x: 94.2321,
    y: 256.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter104_f_2550_59381",
    x: 90.038,
    y: 250.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter105_f_2550_59381",
    x: 115.522,
    y: 257.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter106_i_2550_59381",
    x: 94.2321,
    y: 237.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter107_f_2550_59381",
    x: 90.038,
    y: 234.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter108_f_2550_59381",
    x: 115.522,
    y: 241.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter109_i_2550_59381",
    x: 94.2321,
    y: 221.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter110_f_2550_59381",
    x: 97.038,
    y: 217.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter111_f_2550_59381",
    x: 122.522,
    y: 224.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter112_i_2550_59381",
    x: 101.232,
    y: 204.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter113_f_2550_59381",
    x: 38.2703,
    y: 279.637,
    width: 35.1518,
    height: 39.1133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter114_f_2550_59381",
    x: 58.7872,
    y: 276.592,
    width: 24.7251,
    height: 24.6973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter115_i_2550_59381",
    x: 33.0757,
    y: 259.811,
    width: 39.1285,
    height: 34.4531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter116_f_2550_59381",
    x: 193.203,
    y: 263,
    width: 82,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter117_f_2550_59381",
    x: 213.038,
    y: 263.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter118_f_2550_59381",
    x: 238.522,
    y: 270.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter119_i_2550_59381",
    x: 217.232,
    y: 250.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter120_f_2550_59381",
    x: 214.038,
    y: 247.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter121_f_2550_59381",
    x: 239.522,
    y: 254.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter122_i_2550_59381",
    x: 218.232,
    y: 234.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter123_f_2550_59381",
    x: 214.038,
    y: 228.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter124_f_2550_59381",
    x: 239.522,
    y: 235.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter125_i_2550_59381",
    x: 218.232,
    y: 215.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter126_f_2550_59381",
    x: 214.038,
    y: 212.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter127_f_2550_59381",
    x: 239.522,
    y: 219.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter128_i_2550_59381",
    x: 218.232,
    y: 199.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter129_f_2550_59381",
    x: 215.038,
    y: 196.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter130_f_2550_59381",
    x: 240.522,
    y: 203.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter131_i_2550_59381",
    x: 219.232,
    y: 183.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter132_f_2550_59381",
    x: 215.038,
    y: 179.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter133_f_2550_59381",
    x: 240.522,
    y: 186.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter134_i_2550_59381",
    x: 219.232,
    y: 166.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter135_f_2550_59381",
    x: 215.038,
    y: 160.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter136_f_2550_59381",
    x: 240.522,
    y: 167.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter137_i_2550_59381",
    x: 219.232,
    y: 147.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter138_f_2550_59381",
    x: 220.038,
    y: 144.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter139_f_2550_59381",
    x: 245.522,
    y: 151.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter140_i_2550_59381",
    x: 224.232,
    y: 131.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter141_f_2550_59381",
    x: 208.038,
    y: 129.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter142_f_2550_59381",
    x: 233.522,
    y: 136.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter143_i_2550_59381",
    x: 212.232,
    y: 116.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter144_f_2550_59381",
    x: 160.038,
    y: 281.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter145_f_2550_59381",
    x: 185.522,
    y: 288.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter146_i_2550_59381",
    x: 164.232,
    y: 268.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter147_f_2550_59381",
    x: 166.038,
    y: 260.707,
    width: 28.748,
    height: 34.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter148_f_2550_59381",
    x: 191.522,
    y: 267.152,
    width: 16.54,
    height: 25.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2550_59381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter149_i_2550_59381",
    x: 170.232,
    y: 247.713,
    width: 45.1416,
    height: 26.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2550_59381"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.03311
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2550_59381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2550_59381",
    x1: 98.5274,
    y1: 227.679,
    x2: 146.6,
    y2: 214.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2550_59381",
    x1: 98.5274,
    y1: 227.679,
    x2: 146.6,
    y2: 214.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2550_59381",
    x1: 99.5274,
    y1: 211.679,
    x2: 147.6,
    y2: 198.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2550_59381",
    x1: 99.5274,
    y1: 211.679,
    x2: 147.6,
    y2: 198.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2550_59381",
    x1: 99.5274,
    y1: 192.679,
    x2: 147.6,
    y2: 179.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2550_59381",
    x1: 99.5274,
    y1: 192.679,
    x2: 147.6,
    y2: 179.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2550_59381",
    x1: 99.5274,
    y1: 176.679,
    x2: 147.6,
    y2: 163.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2550_59381",
    x1: 99.5274,
    y1: 176.679,
    x2: 147.6,
    y2: 163.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2550_59381",
    x1: 100.527,
    y1: 160.679,
    x2: 148.6,
    y2: 147.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2550_59381",
    x1: 100.527,
    y1: 160.679,
    x2: 148.6,
    y2: 147.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2550_59381",
    x1: 100.527,
    y1: 143.679,
    x2: 148.6,
    y2: 130.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2550_59381",
    x1: 100.527,
    y1: 143.679,
    x2: 148.6,
    y2: 130.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2550_59381",
    x1: 100.527,
    y1: 124.679,
    x2: 148.6,
    y2: 111.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2550_59381",
    x1: 100.527,
    y1: 124.679,
    x2: 148.6,
    y2: 111.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2550_59381",
    x1: 100.527,
    y1: 107.679,
    x2: 148.6,
    y2: 94.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2550_59381",
    x1: 100.527,
    y1: 107.679,
    x2: 148.6,
    y2: 94.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2550_59381",
    x1: 88.5274,
    y1: 96.6788,
    x2: 136.6,
    y2: 83.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2550_59381",
    x1: 88.5274,
    y1: 96.6788,
    x2: 136.6,
    y2: 83.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2550_59381",
    x1: 168.527,
    y1: 179.679,
    x2: 216.6,
    y2: 166.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2550_59381",
    x1: 168.527,
    y1: 179.679,
    x2: 216.6,
    y2: 166.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2550_59381",
    x1: 169.527,
    y1: 163.679,
    x2: 217.6,
    y2: 150.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2550_59381",
    x1: 169.527,
    y1: 163.679,
    x2: 217.6,
    y2: 150.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2550_59381",
    x1: 169.527,
    y1: 144.679,
    x2: 217.6,
    y2: 131.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2550_59381",
    x1: 169.527,
    y1: 144.679,
    x2: 217.6,
    y2: 131.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2550_59381",
    x1: 169.527,
    y1: 128.679,
    x2: 217.6,
    y2: 115.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2550_59381",
    x1: 169.527,
    y1: 128.679,
    x2: 217.6,
    y2: 115.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2550_59381",
    x1: 170.527,
    y1: 112.679,
    x2: 218.6,
    y2: 99.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2550_59381",
    x1: 170.527,
    y1: 112.679,
    x2: 218.6,
    y2: 99.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2550_59381",
    x1: 170.527,
    y1: 95.6788,
    x2: 218.6,
    y2: 82.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2550_59381",
    x1: 170.527,
    y1: 95.6788,
    x2: 218.6,
    y2: 82.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2550_59381",
    x1: 170.527,
    y1: 76.6788,
    x2: 218.6,
    y2: 63.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2550_59381",
    x1: 170.527,
    y1: 76.6788,
    x2: 218.6,
    y2: 63.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2550_59381",
    x1: 170.527,
    y1: 59.6788,
    x2: 218.6,
    y2: 46.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2550_59381",
    x1: 170.527,
    y1: 59.6788,
    x2: 218.6,
    y2: 46.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2550_59381",
    x1: 179.527,
    y1: 43.6788,
    x2: 227.6,
    y2: 30.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2550_59381",
    x1: 179.527,
    y1: 43.6788,
    x2: 227.6,
    y2: 30.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2550_59381",
    x1: 150.527,
    y1: 269.679,
    x2: 198.6,
    y2: 256.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2550_59381",
    x1: 150.527,
    y1: 269.679,
    x2: 198.6,
    y2: 256.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2550_59381",
    x1: 151.527,
    y1: 253.679,
    x2: 199.6,
    y2: 240.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2550_59381",
    x1: 151.527,
    y1: 253.679,
    x2: 199.6,
    y2: 240.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2550_59381",
    x1: 151.527,
    y1: 234.679,
    x2: 199.6,
    y2: 221.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2550_59381",
    x1: 151.527,
    y1: 234.679,
    x2: 199.6,
    y2: 221.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2550_59381",
    x1: 151.527,
    y1: 218.679,
    x2: 199.6,
    y2: 205.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2550_59381",
    x1: 151.527,
    y1: 218.679,
    x2: 199.6,
    y2: 205.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2550_59381",
    x1: 145.527,
    y1: 204.679,
    x2: 193.6,
    y2: 191.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2550_59381",
    x1: 145.527,
    y1: 204.679,
    x2: 193.6,
    y2: 191.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2550_59381",
    x1: 146.527,
    y1: 185.679,
    x2: 194.6,
    y2: 172.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2550_59381",
    x1: 146.527,
    y1: 185.679,
    x2: 194.6,
    y2: 172.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2550_59381",
    x1: 33.5274,
    y1: 268.679,
    x2: 81.6002,
    y2: 255.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2550_59381",
    x1: 33.5274,
    y1: 268.679,
    x2: 81.6002,
    y2: 255.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2550_59381",
    x1: 34.5274,
    y1: 252.679,
    x2: 82.6002,
    y2: 239.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2550_59381",
    x1: 34.5274,
    y1: 252.679,
    x2: 82.6002,
    y2: 239.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2550_59381",
    x1: 34.5274,
    y1: 233.679,
    x2: 82.6002,
    y2: 220.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2550_59381",
    x1: 34.5274,
    y1: 233.679,
    x2: 82.6002,
    y2: 220.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2550_59381",
    x1: 34.5274,
    y1: 217.679,
    x2: 82.6002,
    y2: 204.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2550_59381",
    x1: 34.5274,
    y1: 217.679,
    x2: 82.6002,
    y2: 204.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2550_59381",
    x1: 37.5274,
    y1: 203.679,
    x2: 85.6002,
    y2: 190.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2550_59381",
    x1: 37.5274,
    y1: 203.679,
    x2: 85.6002,
    y2: 190.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2550_59381",
    x1: 38.5274,
    y1: 184.679,
    x2: 86.6002,
    y2: 171.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2550_59381",
    x1: 38.5274,
    y1: 184.679,
    x2: 86.6002,
    y2: 171.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2550_59381",
    x1: 88.5273,
    y1: 302.679,
    x2: 136.6,
    y2: 289.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2550_59381",
    x1: 88.5273,
    y1: 302.679,
    x2: 136.6,
    y2: 289.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2550_59381",
    x1: 89.5273,
    y1: 286.679,
    x2: 137.6,
    y2: 273.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2550_59381",
    x1: 89.5273,
    y1: 286.679,
    x2: 137.6,
    y2: 273.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2550_59381",
    x1: 89.5273,
    y1: 267.679,
    x2: 137.6,
    y2: 254.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2550_59381",
    x1: 89.5273,
    y1: 267.679,
    x2: 137.6,
    y2: 254.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2550_59381",
    x1: 89.5273,
    y1: 251.679,
    x2: 137.6,
    y2: 238.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2550_59381",
    x1: 89.5273,
    y1: 251.679,
    x2: 137.6,
    y2: 238.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2550_59381",
    x1: 96.5273,
    y1: 234.679,
    x2: 144.6,
    y2: 221.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2550_59381",
    x1: 96.5273,
    y1: 234.679,
    x2: 144.6,
    y2: 221.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2550_59381",
    x1: 41.4028,
    y1: 307.112,
    x2: 71.3996,
    y2: 267.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2550_59381",
    x1: 41.4028,
    y1: 307.112,
    x2: 71.3996,
    y2: 267.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2550_59381",
    x1: 212.527,
    y1: 280.679,
    x2: 260.6,
    y2: 267.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2550_59381",
    x1: 212.527,
    y1: 280.679,
    x2: 260.6,
    y2: 267.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2550_59381",
    x1: 213.527,
    y1: 264.679,
    x2: 261.6,
    y2: 251.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2550_59381",
    x1: 213.527,
    y1: 264.679,
    x2: 261.6,
    y2: 251.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2550_59381",
    x1: 213.527,
    y1: 245.679,
    x2: 261.6,
    y2: 232.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2550_59381",
    x1: 213.527,
    y1: 245.679,
    x2: 261.6,
    y2: 232.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2550_59381",
    x1: 213.527,
    y1: 229.679,
    x2: 261.6,
    y2: 216.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2550_59381",
    x1: 213.527,
    y1: 229.679,
    x2: 261.6,
    y2: 216.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2550_59381",
    x1: 214.527,
    y1: 213.679,
    x2: 262.6,
    y2: 200.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2550_59381",
    x1: 214.527,
    y1: 213.679,
    x2: 262.6,
    y2: 200.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2550_59381",
    x1: 214.527,
    y1: 196.679,
    x2: 262.6,
    y2: 183.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2550_59381",
    x1: 214.527,
    y1: 196.679,
    x2: 262.6,
    y2: 183.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2550_59381",
    x1: 214.527,
    y1: 177.679,
    x2: 262.6,
    y2: 164.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2550_59381",
    x1: 214.527,
    y1: 177.679,
    x2: 262.6,
    y2: 164.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2550_59381",
    x1: 219.527,
    y1: 161.679,
    x2: 267.6,
    y2: 148.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2550_59381",
    x1: 219.527,
    y1: 161.679,
    x2: 267.6,
    y2: 148.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2550_59381",
    x1: 207.527,
    y1: 146.679,
    x2: 255.6,
    y2: 133.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2550_59381",
    x1: 207.527,
    y1: 146.679,
    x2: 255.6,
    y2: 133.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2550_59381",
    x1: 159.527,
    y1: 298.679,
    x2: 207.6,
    y2: 285.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2550_59381",
    x1: 159.527,
    y1: 298.679,
    x2: 207.6,
    y2: 285.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2550_59381",
    x1: 165.527,
    y1: 277.679,
    x2: 213.6,
    y2: 264.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2550_59381",
    x1: 165.527,
    y1: 277.679,
    x2: 213.6,
    y2: 264.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2550_59381",
    x1: 5.59907,
    y1: 39.0024,
    x2: 43.3649,
    y2: 31.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2550_59381",
    x1: 3.89987,
    y1: 27.1659,
    x2: 30.2045,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTifiJackpot);
export default __webpack_public_path__ + "static/media/tifi-jackpot.1ca47e5780c55e4903025e892016e174.svg";
export { ForwardRef as ReactComponent };